// CRM-specific ru catalog (flat keys, matching `<scope>.<domain>.<key>`).
// Namespace is `crm` — access via `t('crm.nav.dashboard')` etc.
//
// Phase 1 keeps only the strings rendered by AppLayout / Sidebar / Topbar.
// Page-level strings land here as pages are built (Week 4+).

import type { Namespace } from '@govard/i18n-core';

export const crmRu: Namespace = {
  'chat.planner_first.read_failed':
    'Не удалось полностью проверить и прочитать данные по запросу. Частичный результат не показан. Уточните запрос или повторите его позже.',
  'chat.planner_first.single_write_failed':
    'Не удалось безопасно проверить действие целиком. Ничего не выполнено. Уточните запрос или повторите его позже.',
  'chat.planner_first.batch_failed':
    'Не удалось безопасно проверить весь пакет действий. Действия не подготовлены и не выполнены. Уточните запрос или повторите его позже.',
  'chat.planner_first.unclassified_failed':
    'Не удалось безопасно проверить запрос целиком. Ничего не выполнено. Уточните запрос или повторите его позже.',
  'chat.planner_first.read_not_found':
    'Подходящая запись не найдена. Проверьте имя или укажите другое.',
  'chat.planner_first.read_too_many':
    'Подходящих записей слишком много. Уточните имя, прежде чем выбирать запись.',
  'chat.planner_first.read_choose':
    'Найдено несколько записей. Выберите запись по номеру или точному названию:',
  'chat.planner_first.read_confirm': 'Нашёл сделку «{label}» — это она?',
  'chat.planner_first.read_selection_unavailable':
    'Сохранённый выбор недоступен или изменился. Повторите исходный запрос, чтобы получить актуальный список.',

  'ai_chat.simple_missing.note_target': 'контакт или сделка',
  'chat.crm_read.field.contacts_count': 'Количество контактов',
  'ai_chat.simple_missing.message':
    'Уточните недостающие поля: {fields}. Без этих сведений запрос нельзя безопасно выполнить.',
  'ai_chat.simple_missing.description': 'описание',
  'ai_chat.simple_missing.task': 'задача',
  'ai_chat.simple_missing.contact': 'контакт',
  'ai_chat.simple_missing.company': 'компания',
  'ai_chat.simple_missing.deal': 'сделка',
  'ai_chat.simple_missing.status': 'статус',
  'ai_chat.simple_missing.first_name': 'имя контакта',
  'ai_chat.simple_missing.note_body': 'текст заметки',
  'ai_chat.simple_missing.stage': 'этап сделки',
  'ai_chat.simple_missing.relation': 'связанная запись',
  'ai_chat.normalization_field.message':
    'Не удалось понять формат поля «{field}». Укажите его в более точном виде.',
  'ai_chat.normalization_field.dueAt': 'дата и время',
  'ai_chat.normalization_field.startsAt': 'дата и время начала',
  'ai_chat.normalization_field.endsAt': 'дата и время окончания',
  'ai_chat.normalization_field.amount': 'сумма',
  'ai_chat.normalization_field.title': 'название',
  'ai_chat.normalization_field.specialTarget': 'нужная запись',
  'ai_chat.normalization_field.phone': 'телефон',
  'ai_chat.normalization_field.email': 'email',
  'ai_chat.normalization_field.contacts': 'данные контактов',
  'ai_chat.normalization_field.operations': 'состав действий',
  'chat.simple.create_task': 'Создать задачу',
  'chat.simple.update_task': 'Изменить задачу',
  'chat.simple.create_deal': 'Создать сделку',
  'chat.simple.search_contacts': 'Найти контакты',
  'chat.simple.read_contact': 'Показать контакт',
  'chat.simple.search_companies': 'Найти компании',
  'chat.simple.read_company': 'Показать компанию',
  'chat.simple.disabled':
    'Этот способ выполнения команды пока не включён для рабочего пространства.',
  'chat.simple.time_required':
    'Укажите точное время выполнения задачи. Дата из исходного запроса сохранена.',
  'ai_chat.quota.exceeded':
    'Месячный лимит AI-токенов исчерпан. Попробуйте снова в следующем месяце.',
  'ai_chat.quota.storage_exceeded':
    'Недостаточно места по тарифу. Удалите файлы или обратитесь к администратору.',
  'ai_chat.history.load_earlier': 'Загрузить ранее',
  'ai_chat.history.load_error': 'Не удалось загрузить ранние сообщения. Попробуйте ещё раз.',
  'ai_chat.handoff.invalid_command': 'Уточните параметры действия и попробуйте ещё раз.',
  'ai_chat.handoff.clarify_deal':
    'Не удалось найти указанную сделку в текущем рабочем пространстве. Выберите сделку ещё раз.',
  'ai_chat.handoff.select_note': 'Выберите заметку, из которой нужно извлечь задачи',
  'ai_chat.handoff.clarify_note':
    'Не удалось прочитать указанную заметку. Выберите доступную заметку ещё раз.',
  'ai_chat.handoff.clarify_selection':
    'Выбранные записи больше недоступны в этом обзоре. Обновите обзор и выберите записи ещё раз.',
  'ai_chat.project_delete_impact.title': 'Проект',
  'ai_chat.project_delete_impact.unchanged':
    'Это только объяснение: проект и связанные данные не изменены.',
  'ai_chat.project_delete_impact.effects': 'При удалении проекта:',
  'ai_chat.project_delete_impact.project': 'Проект исчезнет из активных списков.',
  'ai_chat.project_delete_impact.children':
    'Задачи и события календаря сохранятся, но их связь с проектом будет удалена.',
  'ai_chat.project_delete_impact.notes':
    'Связи заметок с проектом и состав участников будут удалены. Сами заметки сохранятся.',
  'ai_chat.project_delete_impact.restore':
    'Пользовательское восстановление проекта не поддерживается.',
  'ai_chat.project_delete_impact.counts': 'Сейчас связано с проектом:',
  'ai_chat.project_delete_impact.tasks': 'Задачи: {count}',
  'ai_chat.project_delete_impact.meetings': 'События календаря: {count}',
  'ai_chat.project_delete_impact.note_links': 'Связи заметок: {count}',
  'ai_chat.project_delete_impact.members': 'Участники: {count}',
  'ai_chat.project_delete_impact.unavailable': 'Количество задач недоступно с вашими правами.',
  'ai_chat.project_delete_impact.status.planned': 'Запланирован',
  'ai_chat.project_delete_impact.status.active': 'Активен',
  'ai_chat.project_delete_impact.status.on_hold': 'Приостановлен',
  'ai_chat.project_delete_impact.status.completed': 'Завершён',
  'ai_chat.project_delete_impact.status.cancelled': 'Отменён',
  'ai_chat.memory_delete.clarification':
    'Не удалось однозначно определить сохранённое предпочтение и его актуальную версию. Уточните, какой факт нужно забыть. Данные CRM не изменены.',
  'deal_detail.probability': 'Вероятность закрытия',
  'deal_detail.health': 'Здоровье сделки',
  'deal_detail.health_short': 'Здоровье',
  'deal_detail.activity_short': 'Активность',
  'deal_detail.tasks_short': 'Задачи',
  'deal_detail.task_counts_hint': 'открыто / просрочено',
  'deal_detail.all_stage_changes': 'Все изменения стадий',
  'deal_detail.summary': 'Сводка',
  'deal_detail.details': 'Детали',
  'deal_detail.tasks_open_overdue': 'Задачи: открыто / просрочено',
  'deal_detail.step_overdue_since': 'Просрочен с {date}',
  'enum.deal_stage.new': 'Новая',
  'enum.deal_stage.contacted': 'Контакт установлен',
  'enum.deal_stage.negotiation': 'Переговоры',
  'enum.deal_stage.won': 'Выиграна',
  'enum.deal_stage.lost': 'Проиграна',
  'deal_detail.next_step': 'Следующий контакт',
  'deal_detail.not_planned': 'Не назначен',
  'deal_detail.assign_contact': 'Назначить',
  'deal_detail.change_contact': 'Изменить',
  'deal_detail.clear': 'Очистить',
  'deal_detail.next_contact_saved': 'Следующий контакт обновлён',
  'deal_detail.preset_today': 'Сегодня 18:00',
  'deal_detail.preset_tomorrow': 'Завтра 10:00',
  'deal_detail.preset_three_days': 'Через 3 дня',
  'deal_detail.preset_week': 'Через неделю',
  'entity_detail.relative_short.now': 'только что',
  'entity_detail.relative_short.minute_past': '{count} мин назад',
  'entity_detail.relative_short.hour_past': '{count} ч назад',
  'entity_detail.relative_short.day_past': '{count} дн назад',
  'entity_detail.relative_short.minute_future': 'через {count} мин',
  'entity_detail.relative_short.hour_future': 'через {count} ч',
  'entity_detail.relative_short.day_future': 'через {count} дн',
  'deal_detail.plan': 'Запланировать',
  'deal_detail.plan_step': 'Запланировать шаг',
  'deal_detail.stage': 'Стадия',
  'deal_detail.company': 'Компания',
  'deal_detail.delete': 'Удалить сделку',
  'deal_detail.pipeline': 'Стадии сделки',
  'deal_detail.won': 'Выиграна',
  'deal_detail.lost': 'Проиграна',
  'deal_detail.move_confirm': 'Перевести в «{stage}»?',
  'deal_detail.stage_changed': 'Стадия изменена: {stage}',
  'deal_detail.loss_reason': 'Причина проигрыша',
  'deal_detail.stage_history': 'Изменения стадий',
  'deal_detail.history_all': 'Все',
  'deal_detail.history_stages': 'Стадии',
  'deal_detail.history_tasks': 'Задачи',
  'deal_detail.history_notes': 'Заметки',
  'deal_detail.replace_company': 'Заменить компанию на компанию контакта?',
  'deal_detail.company_mismatch': 'Компания не связана с контактом — контакт будет очищен',
  'deal_detail.other_source': 'Другое…',
  'deal_detail.partial_create':
    'Сделка создана, но дополнительные поля не сохранены. Повторите сохранение.',
  'deal_detail.risk_healthy': 'Низкий риск',
  'deal_detail.risk_attention': 'Средний риск',
  'deal_detail.risk_critical': 'Высокий риск',
  'deal_detail.event_stage': 'Стадия',
  'deal_detail.event_task': 'Задача',
  'deal_detail.event_note': 'Заметка',
  'deal_detail.event_meeting': 'Встреча',
  'deal_detail.event_file': 'Файл',
  'deal_detail.event_other': 'Активность',
  'deal_detail.reason_missing_next_activity': 'Не назначен следующий контакт',
  'deal_detail.reason_overdue_next_activity': 'Следующий контакт просрочен',
  'deal_detail.reason_stale_activity': 'Давно не было активности',
  'deal_detail.reason_stage_age_over_norm': 'Сделка задержалась на стадии',
  'deal_detail.reason_qualification_gaps': 'Не хватает данных квалификации',
  'deal_detail.reason_overdue_task': 'Есть просроченные задачи',
  'deal_detail.reason_stage_new': 'Начальная стадия',
  'deal_detail.reason_stage_contacted': 'Контакт установлен',
  'deal_detail.reason_stage_negotiation': 'Переговоры',
  'deal_detail.reason_zero_amount': 'Сумма не указана',
  'deal_detail.reason_closed_won': 'Сделка выиграна',
  'deal_detail.reason_closed_lost': 'Сделка проиграна',
  'enum.tag.cold': 'Холодный',
  'enum.tag.warm': 'Тёплый',
  'enum.tag.new': 'Новый',
  'enum.tag.vip': 'VIP',
  'enum.tag.phone-only': 'Только звонки',
  'enum.tag.stale': 'Спящий',
  'enum.tag.high-value': 'Крупный чек',
  'enum.tag.lost-price': 'Отказ: цена',
  'enum.contact_source.website': 'Сайт',
  'enum.contact_source.instagram': 'Instagram',
  'enum.contact_source.referral': 'Рекомендация',
  'enum.contact_source.phone': 'Телефон',
  'enum.contact_source.telegram': 'Telegram',
  'entity_detail.tags': 'Теги',
  'entity_detail.company_edit': 'Изменить компанию',
  'entity_detail.add': 'Добавить',
  'entity_detail.note_shortcut': 'Ctrl+Enter — быстро сохранить',
  'entity_detail.delete_contact': 'Удалить контакт',
  'entity_detail.delete_note': 'Удалить заметку',
  'entity_detail.sort': 'Сортировка',
  'entity_detail.sort_due': 'По сроку',
  'entity_detail.sort_priority': 'По приоритету',
  'entity_detail.sort_title': 'По названию',
  'entity_detail.sort_amount': 'По сумме',
  'entity_detail.sort_stage': 'По стадии',
  'entity_detail.sort_updated': 'По обновлению',
  'entity_detail.task_status': 'Статус задачи «{title}»',
  'entity_detail.meeting_unmarked': 'Не отмечена',
  'entity_detail.download_ics': 'Скачать .ics',
  'entity_detail.cancel_meeting': 'Отменить встречу',
  'entity_detail.cancel_meeting_confirm': 'Отменить встречу?',
  'entity_detail.all_tags': 'Все теги',
  'entity_detail.more_actions': 'Другие действия',
  'entity_detail.row_actions': 'Действия для «{title}»',
  'entity_detail.copy': 'Скопировать',
  'entity_detail.copied': 'Скопировано',
  'entity_detail.interaction_call': 'Звонок',
  'entity_detail.interaction_email': 'Письмо',
  'entity_detail.interaction_meeting': 'Встреча',
  'entity_detail.interaction_note': 'Заметка',
  'entity_detail.interaction_sms': 'SMS',
  'entity_detail.interaction_in_app': 'Сообщение',
  'entity_detail.confirm': 'Подтвердить',
  'entity_detail.cancel': 'Отмена',
  'entity_detail.tabs': 'Разделы карточки',
  'entity_detail.more_tabs': 'Ещё',
  'entity_detail.overview': 'Обзор',
  'entity_detail.summary': 'Сводка',
  'entity_detail.links': 'Связи',
  'entity_detail.open_chat': 'Открыть AI-чат',
  'entity_detail.edit_document_text': 'Редактировать текст →',
  'entity_detail.deals': 'Сделки',
  'entity_detail.tasks': 'Задачи',
  'entity_detail.meetings': 'Встречи',
  'entity_detail.notes': 'Заметки',
  'entity_detail.documents': 'Документы',
  'entity_detail.files': 'Файлы',
  'entity_detail.history': 'История',
  'entity_detail.today': 'Сегодня',
  'entity_detail.yesterday': 'Вчера',
  'entity_detail.overdue_days': 'Просрочено {count} дн.',
  'entity_detail.overdue_since': 'Просрочено с {date}',
  'entity_detail.overdue_tasks': 'Просроченные ({count})',
  'entity_detail.all_tasks': 'Все задачи',
  'entity_detail.show_more': 'Показать ещё',
  'entity_detail.show_less': 'Свернуть',
  'entity_detail.load_error': 'Не удалось загрузить данные',
  'entity_detail.save_error': 'Не удалось сохранить изменения',
  'entity_detail.save': 'Сохранить',
  'entity_detail.new_note': 'Напишите заметку…',
  'entity_detail.empty_notes': 'Заметок пока нет',
  'entity_detail.empty_history': 'Активности пока нет',
  'entity_detail.empty_deals': 'Связанных сделок пока нет',
  'entity_detail.empty_tasks': 'Задач пока нет',
  'entity_detail.empty_meetings': 'Встреч пока нет',
  'entity_detail.empty_documents': 'Документов пока нет',
  'entity_detail.empty_files': 'Файлов пока нет',
  'entity_detail.empty_overview': 'Пока нет описания, запланированных действий или истории',
  'entity_detail.add_deal': 'Сделка',
  'entity_detail.add_task': 'Задача',
  'entity_detail.add_meeting': 'Встреча',
  'entity_detail.add_document': 'Документ',
  'entity_detail.add_file': 'Загрузить файл',
  'entity_detail.add_interaction': 'Записать взаимодействие',
  'entity_detail.edit': 'Редактировать',
  'entity_detail.delete': 'Удалить',
  'entity_detail.delete_confirm': 'Удалить запись?',
  'entity_detail.delete_description': 'Запись будет удалена. Это действие нельзя отменить.',
  'entity_detail.download': 'Скачать',
  'entity_detail.search': 'Поиск по названию',
  'entity_detail.active_deals': 'Активные сделки',
  'entity_detail.last_activity': 'Последняя активность',
  'entity_detail.details': 'Детали контакта',
  'entity_detail.description': 'Описание',
  'entity_detail.next_task': 'Ближайшая',
  'entity_detail.next_meeting': 'Ближайшая встреча',
  'entity_detail.recent_history': 'Последние активности',
  'entity_detail.created': 'Создан',
  'entity_detail.updated': 'Обновлён',
  'entity_detail.role': 'Должность',
  'entity_detail.completed_tasks': 'Завершённые задачи ({count})',
  'entity_detail.complete_task': 'Завершить задачу «{title}»',
  'entity_detail.reopen_task': 'Вернуть задачу «{title}» в работу',
  'entity_detail.task_completed': 'Задача завершена',
  'entity_detail.undo': 'Отменить',
  'entity_detail.contact_unavailable': 'Контакт не найден',
  'entity_detail.write': 'Написать',
  'entity_detail.call': 'Позвонить',
  'entity_detail.task_todo': 'К выполнению',
  'entity_detail.task_in_progress': 'В работе',
  'entity_detail.task_blocked': 'Заблокирована',
  'entity_detail.task_done': 'Завершена',
  'entity_detail.task_cancelled': 'Отменена',
  'entity_detail.meeting_scheduled': 'Запланирована',
  'entity_detail.meeting_completed': 'Состоялась',
  'entity_detail.meeting_cancelled': 'Отменена',
  'ai_chat.memory_update.clarification':
    'Не удалось однозначно определить сохранённое предпочтение и его актуальную версию. Уточните, какой факт нужно изменить. Данные CRM не изменены.',
  'ai_chat.proposal.title': 'Редактируемое предложение задачи',
  'ai_chat.proposal.create_effect': 'Подтверждение создаст эту задачу',
  'ai_chat.proposal.update_effect': 'Подтверждение изменит эту задачу',
  'ai_chat.proposal.revision': 'Ревизия {number}',
  'ai_chat.proposal.task_title': 'Название',
  'ai_chat.proposal.description': 'Описание',
  'ai_chat.proposal.due_at': 'Срок',
  'ai_chat.proposal.priority': 'Приоритет',
  'ai_chat.proposal.priority_low': 'Низкий',
  'ai_chat.proposal.priority_medium': 'Средний',
  'ai_chat.proposal.priority_high': 'Высокий',
  'ai_chat.proposal.priority_urgent': 'Срочный',
  'ai_chat.proposal.assignee': 'Исполнитель',
  'ai_chat.proposal.unassigned': 'Не назначен',
  'ai_chat.proposal.save': 'Сохранить предложение',
  'ai_chat.proposal.unsaved': 'Сохраните изменения перед подтверждением',
  'ai_chat.proposal.save_error':
    'Не удалось сохранить предложение. Обновите страницу и повторите попытку.',
  'ai_chat.proposal.load_error':
    'Не удалось проверить предложение. Обновите страницу перед подтверждением.',
  'ai_chat.proposal.conflict': 'Предложение изменилось. Обновите страницу перед новой правкой.',
  'ai_chat.proposal.invalid_date': 'Укажите корректные дату и время срока.',
  'ai_chat.proposal.read_only': 'Это предложение уже нельзя изменить или подтвердить.',
  'ai_chat.proposal.saved_without_approval':
    'Изменения сохранены, но подтверждение недоступно. Попросите в чате повторно отправить предложение.',
  'common.cancel': 'Отмена',
  // List-page chrome for the sections brought to the shared list standard.
  'meetings.list.view_label': 'Вид отображения',
  'meetings.list.refresh': 'Обновить',
  'meetings.list.search_label': 'Поиск по встречам',
  'meetings.list.status_label': 'Фильтр по статусу',
  'notes.new': 'Новая заметка',
  'notes.list.search_label': 'Поиск по заметкам',
  'settings.field.email': 'Email',
  'settings.field.workspace_id': 'ID рабочего пространства',
  'settings.field.feature_flags': 'Флаги функций',
  // Count nouns for list subtitles — plural shapes so «1 документ» / «3 документа»
  // / «5 документов» all read correctly (see i18n.tc).
  'counts.documents': { one: 'документ', few: 'документа', many: 'документов', other: 'документа' },
  'counts.projects': { one: 'проект', few: 'проекта', many: 'проектов', other: 'проекта' },
  'counts.meetings': { one: 'встреча', few: 'встречи', many: 'встреч', other: 'встречи' },
  'counts.notes': { one: 'заметка', few: 'заметки', many: 'заметок', other: 'заметки' },
  'counts.templates': { one: 'шаблон', few: 'шаблона', many: 'шаблонов', other: 'шаблона' },
  'counts.approvals': { one: 'запись', few: 'записи', many: 'записей', other: 'записи' },
  'counts.hot_leads': { one: 'сделка', few: 'сделки', many: 'сделок', other: 'сделки' },
  // Sidebar navigation — Simple section (5 canonical items + Settings).
  'nav.dashboard': 'Главная',
  'nav.chat': 'Чат',
  'nav.deals': 'Сделки',
  'nav.tasks': 'Задачи',
  'nav.calendar': 'Календарь',
  'calendar.title': 'Календарь',
  'calendar.subtitle': 'Недельный план: задачи, встречи, лиды из Telegram и дедлайны сделок.',
  'calendar.view.day': 'День',
  'calendar.view.week': 'Неделя',
  'calendar.view.list': 'Список',
  'calendar.nav.today': 'Сегодня',
  'calendar.nav.prev': 'Предыдущий период',
  'calendar.nav.next': 'Следующий период',
  'calendar.nav.prev_hint': 'Предыдущая {period} (←)',
  'calendar.nav.next_hint': 'Следующая {period} (→)',
  'calendar.nav.today_hint': 'Текущая неделя (T)',
  'calendar.period.day': 'день',
  'calendar.period.week': 'неделя',
  'calendar.quick_create.task': 'Задача',
  'calendar.quick_create.meeting': 'Встреча',
  'calendar.quick_create.add': 'Добавить запись на {date}',
  'calendar.overflow.title': 'Все события дня',
  'calendar.filter.task': 'Задачи',
  'calendar.filter.meeting': 'Встречи',
  'calendar.filter.tg': 'Telegram',
  'calendar.filter.deadline': 'Дедлайны',
  'calendar.filter.generic': 'Записи',
  'calendar.zone.all_day': 'Весь день',
  'calendar.day_sections.timed': 'По времени',
  'calendar.empty_day': 'Нет событий',
  'calendar.empty_day_view': 'Нет событий на этот день',
  'calendar.free_day': 'Свободно',
  'calendar.more_events': '+{count} ещё',
  'calendar.overdue': 'Просрочено',
  'calendar.quick_status_done': 'Отметить выполненной',
  'calendar.quick_status_todo': 'Вернуть в работу',
  'calendar.refresh': 'Обновить',
  'calendar.load_error': 'Не удалось загрузить календарь',
  'calendar.source_error.tasks': 'Не удалось загрузить задачи',
  'calendar.source_error.meetings': 'Не удалось загрузить встречи',
  'calendar.source_error.overdue': 'Не удалось загрузить просроченные задачи',
  'calendar.source_error.deals': 'Не удалось загрузить дедлайны сделок',
  'calendar.source_error.telegram': 'Лиды из Telegram не загрузились',
  'calendar.source_error.hint': 'Остальные события календаря показаны',
  'calendar.list.count': {
    one: '{count} событие',
    few: '{count} события',
    many: '{count} событий',
    other: '{count} событий',
  },
  'calendar.list.empty': 'пусто',
  'calendar.list.no_events': 'нет событий',
  'nav.projects': 'Проекты',
  'nav.contacts': 'Контакты',
  'nav.companies': 'Компании',
  'nav.notes': 'Заметки',
  'nav.meetings': 'Встречи',
  'nav.approvals': 'Подтверждения',
  'nav.telegram_candidates': 'Из Telegram',
  'nav.telegram_operations': 'Работа Telegram',
  'telegram_operations.title': 'Работа Telegram',
  'telegram_operations.subtitle': 'Очереди, доставки и privacy-сигналы без содержимого сообщений',
  'telegram_operations.window': 'Период метрик',
  'telegram_operations.windows.1h': 'Последний час',
  'telegram_operations.windows.24h': 'Последние 24 часа',
  'telegram_operations.windows.7d': 'Последние 7 дней',
  'telegram_operations.load_error': 'Не удалось загрузить состояние Telegram',
  'telegram_operations.forbidden':
    'Раздел доступен только владельцам и администраторам пространства.',
  'telegram_operations.ingress': 'Входящие события',
  'telegram_operations.delivery': 'Доставки',
  'telegram_operations.inbound_due': 'Очередь входящих',
  'telegram_operations.delivery_due': 'Очередь доставки',
  'telegram_operations.delivery_success': 'Успешная доставка',
  'telegram_operations.ambiguous': 'Неопределённые доставки',
  'telegram_operations.ingress_p95': 'Обработка входящих p95',
  'telegram_operations.delivery_p95': 'Задержка доставки p95',
  'telegram_operations.rollout': 'Контуры включения',
  'telegram_operations.connections': 'Подключения',
  'telegram_operations.no_connections': 'Подключение Telegram отсутствует',
  'telegram_operations.ref_unavailable': 'Ссылка недоступна, пока интеграция выключена',
  'telegram_operations.connection_status.provisioning': 'Настраивается',
  'telegram_operations.connection_status.active': 'Активно',
  'telegram_operations.connection_status.suspended': 'Приостановлено',
  'telegram_operations.connection_status.revoked': 'Отозвано',
  'telegram_operations.recent': 'Последние доставки без содержимого',
  'telegram_operations.empty': 'За выбранный период доставок нет',
  'telegram_operations.ref': 'Ссылка',
  'telegram_operations.kind': 'Тип',
  'telegram_operations.status': 'Статус',
  'telegram_operations.attempt': 'Попытка',
  'telegram_operations.duration': 'Длительность',
  'telegram_operations.outcome': 'Результат',
  'telegram_operations.on': 'включено',
  'telegram_operations.off': 'выключено',
  'telegram_operations.flags.beta': 'Telegram beta',
  'telegram_operations.flags.inboundWorker': 'Обработка входящих',
  'telegram_operations.flags.deliveryWorker': 'Отправка сообщений',
  'telegram_operations.flags.groupExtraction': 'Извлечение из групп',
  'telegram_operations.flags.approvalResults': 'Результаты подтверждений',
  'telegram_operations.flags.dailyDigest': 'Ежедневная сводка',
  'telegram_operations.alerts.inbound_backlog': 'Очередь входящих превысила рабочий порог.',
  'telegram_operations.alerts.delivery_backlog': 'Очередь доставки превысила рабочий порог.',
  'telegram_operations.alerts.delivery_error_budget':
    'Превышен допустимый уровень ошибок доставки.',
  'telegram_operations.statuses.queued': 'В очереди',
  'telegram_operations.statuses.claimed': 'В обработке',
  'telegram_operations.statuses.sending': 'Отправляется',
  'telegram_operations.statuses.retry_wait': 'Ожидает повтора',
  'telegram_operations.statuses.sent': 'Отправлено',
  'telegram_operations.statuses.ambiguous': 'Неопределённо',
  'telegram_operations.statuses.permanent_failed': 'Не доставлено',
  'telegram_operations.statuses.cancelled': 'Отменено',
  'telegram_operations.kinds.private_agent_response': 'Личный ответ ассистента',
  'telegram_operations.kinds.private_approval_presentation': 'Личное подтверждение',
  'telegram_operations.kinds.group_disclosure': 'Уведомление группы',
  'telegram_operations.kinds.group_status': 'Статус группы',
  'telegram_operations.kinds.group_acknowledgement': 'Подтверждение группы',
  'telegram_operations.kinds.private_approval_result': 'Результат подтверждения',
  'telegram_operations.kinds.private_daily_digest': 'Ежедневная сводка',
  'telegram_operations.outcomes.subscription_disabled': 'Подписка отключена',
  'telegram_operations.outcomes.authority_unavailable': 'Доступ отозван',
  'telegram_operations.outcomes.provider_retryable': 'Временная ошибка Telegram',
  'telegram_operations.outcomes.provider_recipient_unavailable': 'Получатель недоступен',
  'telegram_operations.outcomes.privacy_revoked': 'Доступ отозван по privacy-запросу',
  'telegram_operations.outcomes.other': 'Другой завершённый результат',
  'settings.telegram.privacy_title': 'Ваши данные Telegram',
  'settings.telegram.privacy_description':
    'Экспортируйте или удалите транспортные данные исторической личной связи. Подтверждённые записи CRM не удаляются.',
  'settings.telegram.export_private': 'Экспортировать мои данные',
  'settings.telegram.delete_private': 'Удалить мои данные',
  'settings.telegram.export_title': 'Экспорт личных данных Telegram',
  'settings.telegram.delete_title': 'Удаление личных данных Telegram',
  'settings.telegram.export_description':
    'Экспорт создаётся для текущего авторизованного запроса и не публикуется как постоянный файл.',
  'settings.telegram.delete_warning':
    'Транспортное содержимое и копии личных сообщений будут удалены. Подтверждённые записи CRM сохранятся.',
  'settings.telegram.confirm_phrase': 'УДАЛИТЬ ДАННЫЕ TELEGRAM',
  'settings.telegram.type_phrase': 'Введите «{phrase}» для подтверждения.',
  'settings.telegram.confirmation': 'Фраза подтверждения',
  'settings.telegram.confirm_action': 'Подтвердить',
  'settings.telegram.link_title': 'Личный Telegram-ассистент',
  'settings.telegram.link_description':
    'Подключите свой Telegram к этому пространству CRM. Одноразовая ссылка действует 10 минут.',
  'settings.telegram.link_loading': 'Загрузка состояния Telegram',
  'settings.tabs.integrations': 'Интеграции',
  'settings.calendars.title': 'Внешние календари',
  'settings.calendars.description':
    'Двухсторонняя синхронизация встреч с Google Calendar и Outlook. Подключать и отключать может владелец или администратор.',
  'settings.calendars.unavailable':
    'Интеграция внешних календарей выключена для этого пространства.',
  'settings.calendars.loading': 'Загрузка подключений календарей',
  'settings.calendars.load_error': 'Не удалось загрузить подключения календарей',
  'settings.calendars.provider_google': 'Google Calendar',
  'settings.calendars.provider_outlook': 'Outlook',
  'settings.calendars.connect_google': 'Подключить Google Calendar',
  'settings.calendars.connect_outlook': 'Подключить Outlook',
  'settings.calendars.empty': 'Пока не подключено ни одного календаря.',
  'settings.calendars.error': 'Не удалось изменить подключение календаря',
  'settings.calendars.status_active': 'Синхронизируется',
  'settings.calendars.status_suspended': 'Нужно переподключение',
  'settings.calendars.status_error': 'Ошибка синхронизации',
  'settings.calendars.status_revoked': 'Отключён',
  'settings.calendars.last_sync': 'Последняя синхронизация',
  'settings.calendars.never_synced': 'ещё не синхронизировался',
  'settings.calendars.disconnect': 'Отключить',
  'settings.calendars.disconnect_title': 'Отключить календарь?',
  'settings.calendars.disconnect_description':
    'Синхронизация прекратится. Сами встречи останутся в CRM, связи с внешним календарём удалятся.',
  'settings.calendars.disconnect_confirm': 'Отключить',
  'settings.telegram.link_load_error': 'Не удалось проверить подключение Telegram',
  'settings.telegram.link_active': 'Telegram подключён',
  'settings.telegram.link_active_description':
    'Можно писать боту и получать ответы CRM-ассистента в личном чате.',
  'settings.telegram.link_suspended':
    'Подключение остановлено. Для повторного подключения нужна новая одноразовая ссылка.',
  'settings.telegram.connect': 'Подключить Telegram',
  'settings.telegram.reconnect': 'Подключить снова',
  'settings.telegram.disconnect': 'Отключить Telegram',
  'settings.telegram.disconnect_title': 'Отключить личный Telegram?',
  'settings.telegram.disconnect_description':
    'Бот перестанет принимать ваши сообщения до повторного подключения.',
  'settings.telegram.disconnect_confirm': 'Отключить',
  'settings.telegram.link_error': 'Не удалось изменить подключение Telegram',
  'telegram_candidates.page_title': 'Кандидаты из Telegram',
  'telegram_candidates.subtitle': 'На проверке: {count}',
  'telegram_candidates.empty': 'Новых кандидатов нет',
  'telegram_candidates.load_error': 'Не удалось загрузить кандидатов',
  'telegram_candidates.confidence': 'Уверенность: {value}%',
  'telegram_candidates.source': 'Исходное сообщение',
  'telegram_candidates.source_unavailable': 'Текст источника недоступен',
  'telegram_candidates.title': 'Название',
  'telegram_candidates.description': 'Описание',
  'telegram_candidates.body': 'Текст',
  'telegram_candidates.due_at': 'Срок (ISO)',
  'telegram_candidates.contact': 'Контакт',
  'telegram_candidates.interaction_type': 'Тип взаимодействия',
  'telegram_candidates.subject': 'Тема',
  'telegram_candidates.confirm_changes': 'Подтвердить правки',
  'telegram_candidates.approve': 'Создать в CRM',
  'telegram_candidates.reject': 'Отклонить',
  'telegram_candidates.needs_context': 'Нужен контекст',
  'telegram_candidates.created': 'Запись создана в CRM',
  'telegram_candidates.type.note': 'Заметка',
  'telegram_candidates.type.task': 'Задача',
  'telegram_candidates.type.contact_interaction': 'Взаимодействие с контактом',
  'telegram_candidates.status.pending': 'Ожидает проверки',
  'telegram_candidates.status.needs_context': 'Нужен контекст',
  'telegram_candidates.status.stale': 'Источник изменён',
  'telegram_candidates.status.rejected': 'Отклонено',
  'telegram_candidates.status.expired': 'Истекло',
  'telegram_candidates.status.succeeded': 'Создано в CRM',
  'telegram_candidates.interaction.call': 'Звонок',
  'telegram_candidates.interaction.email': 'Письмо',
  'telegram_candidates.interaction.meeting': 'Встреча',
  'telegram_candidates.interaction.note': 'Заметка',
  'telegram_candidates.interaction.sms': 'SMS',
  'telegram_candidates.interaction.in_app': 'В приложении',
  'telegram_candidates.type.contact': 'Контакт',
  'telegram_candidates.contact_create_new': 'Создать новый контакт',
  'telegram_candidates.first_name': 'Имя',
  'telegram_candidates.last_name': 'Фамилия',
  'telegram_candidates.phone': 'Телефон',
  'telegram_candidates.email': 'Email',
  'telegram_candidates.create_deal': 'Создать сделку',
  'telegram_candidates.deal_title': 'Название сделки',
  'telegram_candidates.deal_amount': 'Сумма',
  'telegram_candidates.duplicate_title': 'Найден существующий контакт',
  'telegram_candidates.duplicate_description':
    'Контакт «{name}» уже есть в CRM. Свяжите кандидата с ним вместо создания дубля.',
  'telegram_candidates.duplicate_link': 'Связать с существующим',
  'telegram_candidates.result_contact': 'Контакт',
  'telegram_candidates.result_deal': 'Сделка',
  'telegram_candidates.agent_turn.action.enrich': 'Обогатить с AI',
  'telegram_candidates.agent_turn.action.enriching': 'Обогащение...',
  'telegram_candidates.agent_turn.confirm.enrich_title': 'Запустить обогащение?',
  'telegram_candidates.agent_turn.confirm.enrich_description':
    'AI-ассистент проанализирует кандидата и предложит улучшенный вариант. Продолжить?',
  'telegram_candidates.agent_turn.success.enriched': 'Кандидат обогащён',
  'telegram_candidates.agent_turn.panel.title': 'Прогон агента',
  'telegram_candidates.agent_turn.error.enrich_failed': 'Не удалось обогатить кандидата',
  'telegram_candidates.agent_turn.error.not_admittable': 'Кандидат недоступен для обогащения',
  'telegram_candidates.agent_turn.error.state_conflict':
    'Версия кандидата изменилась, обновите данные',
  'telegram_candidates.agent_turn.status.completed': 'Завершён',
  'telegram_candidates.agent_turn.status.failed': 'Ошибка',
  'telegram_candidates.agent_turn.status.streaming': 'Выполняется',
  'telegram_candidates.agent_turn.status.queued': 'В очереди',
  'telegram_candidates.agent_turn.status.cancelled': 'Отменён',
  'nav.documents': 'Документы',
  'nav.imports': 'Импорт / Экспорт',
  'nav.templates': 'Шаблоны',
  'nav.workflows': 'Воркфлоу',
  'nav.hot_leads': 'Горячие лиды',
  'nav.memory': 'Память',
  'nav.views': 'Представления',
  'nav.run_center': 'Run Center',
  'nav.automations': 'Автоматизации',
  'nav.scenario_editor': 'Scenario Editor',
  'nav.prompt_compiler': 'Prompt Compiler',
  'nav.knowledge_base': 'База знаний',
  'nav.files': 'Файлы',
  'nav.agents': 'Агенты',
  'nav.opencode': 'OpenCode',
  'nav.settings': 'Настройки',
  'nav.team': 'Команда',

  // Pro-mode collapsible section (empty in Phase 1).
  'nav.pro_section': 'Расширенные (Pro)',
  'nav.pro_empty': 'Здесь появятся инструменты Pro-режима.',
  'nav.coming_soon': 'Скоро',

  // Platform admin navigation (visible only to platform admins).
  'admin.nav.dashboard': 'Админ-панель',
  'admin.nav.users': 'Пользователи',
  'admin.nav.workspaces': 'Воркспейсы',
  'admin.nav.plans': 'Тарифы',
  'admin.nav.llm': 'LLM-затраты',
  'admin.nav.mail': 'Почта',
  'admin.nav.audit': 'Аудит',

  // Sidebar groups / branding.
  'sidebar.simple_section': 'Основное',
  'sidebar.workspace': 'Рабочее пространство',
  'sidebar.brand': 'Govard CRM',

  // Topbar.
  'topbar.user_menu': 'Меню пользователя',
  'topbar.logout': 'Выйти',
  'topbar.toggle_context': 'Контекстная панель',
  'topbar.system_agent': 'Системная панель',
  'topbar.logout_error': 'Не удалось выйти. Попробуйте ещё раз.',
  'topbar.workspace_fallback': 'Без рабочего пространства',
  'topbar.workspace_picker': 'Рабочее пространство',
  'topbar.workspace_personal_suffix': 'личное',
  'topbar.workspace_switch_error': 'Не удалось переключить рабочее пространство.',
  'topbar.workspace_create': 'Создать пространство',
  'topbar.workspace_create_ok': 'Создать',
  'topbar.workspace_create_name': 'Название',
  'topbar.workspace_create_name_placeholder': 'Например, Салон «Аврора»',
  'topbar.workspace_create_error': 'Не удалось создать рабочее пространство.',

  // Right sidebar.
  'right_sidebar.title': 'Контекстная панель',
  'right_sidebar.close': 'Закрыть контекстную панель',
  'right_sidebar.description': 'Shell-панель для operator-контекста и быстрой диагностики.',
  'right_sidebar.system_status': 'Статус системы',
  'right_sidebar.block_status': 'Статус',
  'right_sidebar.status_online': 'Онлайн',
  'right_sidebar.block_scope': 'Scope',
  'right_sidebar.scope_workspace': 'Текущий workspace',
  'right_sidebar.recent_activity': 'Недавняя активность',
  'right_sidebar.activity_visual_contract': 'Визуальный контракт закреплён',
  'right_sidebar.activity_now': 'только что',
  'right_sidebar.activity_next_slice': 'Следующий срез: shell/deals parity',
  'right_sidebar.activity_next': 'следующий шаг',

  // Settings Week 5.
  'settings.title': 'Настройки',
  'settings.subtitle': 'Профиль, рабочее пространство, AI и флаги функций для текущего workspace.',
  'settings.tabs_aria': 'Разделы настроек',
  'settings.tabs.profile': 'Профиль',
  'settings.tabs.workspace': 'Рабочее пространство',
  'settings.tabs.ai': 'AI',
  'settings.tabs.flags': 'Флаги функций',
  'settings.tabs.team': 'Команда',
  'settings.tabs.security': 'Безопасность',
  'settings.tabs.navigation': 'Меню',
  'settings.navigation.subtitle': 'Порядок и видимость пунктов бокового меню ({count} видимых)',
  'settings.navigation.reset': 'Сбросить по умолчанию',
  'settings.navigation.move_group_up': 'Переместить группу «{label}» выше',
  'settings.navigation.move_group_down': 'Переместить группу «{label}» ниже',
  'settings.navigation.move_item_up': 'Переместить пункт «{label}» выше',
  'settings.navigation.move_item_down': 'Переместить пункт «{label}» ниже',
  'settings.navigation.visibility': 'Показывать пункт «{label}»',
  'settings.navigation.visibility_hint': 'Показать или скрыть пункт в боковом меню',
  'settings.navigation.hidden_hint':
    'Скрытые пункты затемнены и исчезают из бокового меню; переключатель возвращает их обратно.',
  'settings.tabs.data': 'Данные',
  'settings.data.title': 'Данные рабочего пространства',
  'settings.data.description':
    'Экспортируйте все записи пространства в один файл или полностью удалите их.',
  'settings.data.export_title': 'Экспорт данных',
  'settings.data.export_description':
    'JSON-файл со всеми сущностями или ZIP-архив с CSV-файлом на каждую сущность.',
  'settings.data.export_format_label': 'Формат экспорта',
  'settings.data.export_format_json': 'JSON',
  'settings.data.export_format_csv': 'CSV (ZIP)',
  'settings.data.export_action': 'Экспортировать данные',
  'settings.data.export_error': 'Не удалось скачать экспорт данных.',
  'settings.data.danger_title': 'Опасная зона',
  'settings.data.danger_description':
    'Удаление стирает все записи пространства — сделки, контакты, компании, задачи, заметки, встречи, документы, шаблоны и вложения. Действие необратимо.',
  'settings.data.delete_action': 'Удалить рабочее пространство',
  'settings.data.delete_title': 'Удалить рабочее пространство?',
  'settings.data.delete_warning':
    'Все данные пространства будут безвозвратно удалены, а сеансы участников завершены. Отменить действие нельзя.',
  'settings.data.delete_acknowledge': 'Я понимаю, что данные будут удалены навсегда',
  'settings.data.delete_password_label': 'Пароль владельца',
  'settings.data.delete_confirm': 'Удалить безвозвратно',
  'settings.data.error.personal_workspace':
    'Личное пространство удалить нельзя — оно привязано к вашему аккаунту.',
  'settings.data.error.last_workspace':
    'Это ваше единственное рабочее пространство. Сначала создайте или подключите другое.',
  'settings.data.error.invalid_password': 'Неверный пароль.',
  'settings.data.error.password_not_set':
    'У аккаунта не задан пароль — установите его перед удалением.',
  'settings.data.error.generic': 'Не удалось удалить рабочее пространство.',
  'settings.tabs.telegram': 'Telegram',
  'settings.telegram.title': 'Уведомления в Telegram',
  'settings.telegram.loading': 'Загружаем настройки уведомлений Telegram...',
  'settings.telegram.load_error': 'Не удалось загрузить настройки уведомлений Telegram.',
  'settings.telegram.unavailable':
    'Привяжите личный чат с Telegram-ботом, чтобы настроить уведомления.',
  'settings.telegram.private_only':
    'Эти уведомления отправляются только в ваш привязанный личный чат с ботом.',
  'settings.telegram.results': 'Результаты действий',
  'settings.telegram.results_description':
    'Получать общий статус после завершения действия, начатого вами в Telegram.',
  'settings.telegram.digest': 'Ежедневная сводка',
  'settings.telegram.digest_description':
    'Только количества ваших просроченных задач, задач на сегодня и ожидающих подтверждений — без данных карточек CRM.',
  'settings.telegram.language': 'Язык уведомлений',
  'settings.telegram.locale_ru': 'Русский',
  'settings.telegram.locale_en': 'Английский',
  'settings.telegram.timezone': 'Часовой пояс',
  'settings.telegram.time': 'Время отправки',
  'settings.telegram.next_send': 'Следующая сводка: {date}',
  'settings.telegram.save_error': 'Не удалось сохранить настройки уведомлений Telegram.',
  'settings.telegram.rollout_disabled':
    'Ежедневные сводки Telegram пока не включены для этого workspace.',
  'settings.conversion_digest.title': 'Дайджест конверсии',
  'settings.conversion_digest.description':
    'Ежедневный пост: топ-5 горячих сделок (название, сумма, стадия, причина, следующий шаг) и сделки без касания N дней. Отдельное согласие — не связан с подписками «Результаты действий» и «Ежедневная сводка».',
  'settings.conversion_digest.loading': 'Загружаем настройки дайджеста конверсии...',
  'settings.conversion_digest.load_error': 'Не удалось загрузить настройки дайджеста конверсии.',
  'settings.conversion_digest.save_error': 'Не удалось сохранить настройки дайджеста конверсии.',
  'settings.conversion_digest.enabled_hint':
    'Доставка в Telegram — только по этому переключателю. Без него дайджест сохраняется заметкой в CRM (если автоматизация активна).',
  'settings.conversion_digest.hour': 'Час доставки',
  'settings.conversion_digest.stagnation_days': 'Дней без касания',
  'settings.conversion_digest.language': 'Язык дайджеста',
  'settings.conversion_digest.telegram_unlinked':
    'Telegram не привязан — дайджест будет сохраняться заметкой в CRM.',
  'settings.loading': 'Загружаем настройки рабочего пространства...',
  'settings.profile_stub': 'Личные настройки профиля и команды появятся в следующих шагах Week 5.',
  'settings.workspace_stub': 'Здесь будут параметры рабочего пространства и участники команды.',
  'settings.ai_stub': 'Настройки моделей и лимитов AI будут доступны после интеграции chat flow.',
  'settings.flags_title': 'Флаги функций',
  'settings.adr_title': 'AI-чат: ADR',
  'settings.adr_simple': 'Простые планы',
  'settings.adr_simple_description': 'Основа планирования в AI-чате.',
  'settings.adr_planner': 'Planner-first',
  'settings.adr_planner_description': 'Планирование чтений и отдельных действий.',
  'settings.adr_compound': 'Составные планы',
  'settings.adr_compound_description': 'Планы из нескольких связанных действий.',
  'settings.adr_batches': 'Пакетные действия',
  'settings.adr_batches_description': 'Планы для обработки нескольких записей.',
  'settings.adr_approve': 'Одобрить всё',
  'settings.adr_approve_description':
    'Одна кнопка подтверждения для всех пунктов пакета вместо подтверждения по одному. Не входит в ADR; проверено только в выключенном состоянии.',
  'settings.adr_requires': 'Нужен:',
  'settings.adr_requires_plural': 'Нужны:',
  'settings.adr_owner_only': 'Изменять настройки может только владелец или администратор.',
  'settings.adr_master': 'ADR',
  'settings.adr_master_description':
    'Новый путь AI-чата со всеми возможностями. Выключение возвращает поведение как в main.',
  'settings.adr_custom': 'Частичная настройка',
  'settings.adr_fine_tuning': 'Тонкая настройка',
  'settings.adr_hint':
    'Работает только с gateway OpenRouter; модель проверена на Gemini 3.5 flash-lite. Изменения применяются к новой беседе.',
  'settings.adr_error_forbidden': 'Недостаточно прав для изменения флагов.',
  'settings.adr_error_failed': 'Не удалось сохранить флаги. Попробуйте ещё раз.',
  'settings.flags_description':
    'Включайте продвинутые режимы только когда готовы к расширенному интерфейсу.',
  'settings.pro_mode_title': 'Pro mode',
  'settings.pro_mode_description': 'Показывает расширенную секцию Advanced (Pro) в боковом меню.',
  'settings.enable_pro_mode': 'Включить Pro mode',
  'settings.disable_pro_mode': 'Выключить Pro mode',
  'settings.confirm_title': 'Включить продвинутый режим?',
  'settings.confirm_body':
    'Появится Scenario Engine, Run Center, Memory Browser. Это для тех, кто хочет тонко настраивать AI-поведение. Основные функции работают и так.',
  'settings.confirm_submit': 'Включить Pro mode',

  // Deals Week 4.
  'deals.title': 'Сделки',
  'deals.subtitle':
    'Канбан по стадиям. Перетаскивайте карточки или используйте быстрый переход в следующую стадию.',
  'deals.loading': 'Загрузка сделок...',
  'deals.load_error': 'Не удалось загрузить сделки',
  'deals.retry': 'Повторить',
  'deals.empty_stage': 'В этой стадии пока нет сделок.',
  'deals.move_to_stage': 'Переместить в {stage}',
  'deals.final_stage': 'Финальная стадия',
  'deals.open_hot_leads': 'Горячие лиды',
  'deals.summary.total': 'Всего сделок',
  'deals.summary.active': 'В работе',
  'deals.summary.attention': 'Нужны действия',
  'deals.next_step': 'Следующий контакт',
  'deals.next_step_missing': 'Не назначен',
  'deals.stage.New': 'Новая',
  'deals.stage.Contacted': 'Контакт установлен',
  'deals.stage.Negotiation': 'Переговоры',
  'deals.stage.Won': 'Успешно',
  'deals.stage.Lost': 'Потеряна',

  // Contacts Week 5.
  'contacts.title': 'Контакты',
  'contacts.subtitle': 'Поиск по базе клиентов, быстрый просмотр и защита от дублей при создании.',
  'contacts.list_title': 'База контактов',
  'contacts.list_description': 'Ищите по имени, email или телефону и открывайте карточку контакта.',
  'contacts.search_label': 'Поиск контактов',
  'contacts.search_submit': 'Найти',
  'contacts.loading': 'Загрузка контактов...',
  'contacts.load_error': 'Не удалось загрузить контакты',
  'contacts.empty': 'Контакты не найдены',
  'contacts.no_channel': 'Контакты не указаны',
  'contacts.create_title': 'Новый контакт',
  'contacts.create_description':
    'Добавьте клиента вручную. Если email уже есть в базе, покажем существующую карточку.',
  'contacts.create_submit': 'Добавить контакт',
  'contacts.form.first_name': 'Имя',
  'contacts.form.last_name': 'Фамилия',
  'contacts.form.email': 'Email',
  'contacts.form.phone': 'Телефон',
  'contacts.duplicate_banner': 'Такой email уже существует',
  'contacts.open_contact': 'Открыть контакт',
  'contacts.summary.total': 'Всего контактов',
  'contacts.summary.with_deals': 'Со сделками',
  'contacts.summary.with_email': 'С email',
  'contacts.back_to_contacts': 'К контактам',
  'contacts.detail.deals': 'Сделки',
  'contacts.detail.notes': 'Заметки',
  'contacts.detail.activity': 'Активность',
  'contacts.detail.role': 'Роль',
  'contacts.detail.company': 'Компания',
  'contacts.mvp.breadcrumbs': 'Контакты / Карточка контакта',
  'contacts.mvp.placeholder.activity': 'Лента активности появится здесь',
  'contacts.mvp.placeholder.deals': 'Таблица сделок появится здесь',
  'contacts.mvp.placeholder.notes': 'Редактор заметок появится здесь',
  'contacts.detail.interactions': 'Последние касания',
  'contacts.detail.no_interactions': 'Контактных событий пока нет.',
  'contacts.detail.source': 'Источник',
  'contacts.detail.source_missing': 'Не указан',

  // Templates Week 5.
  'templates.title': 'Шаблоны',
  'templates.subtitle': 'Каталог готовых шаблонов для писем, SMS и in-app сообщений.',
  'templates.subtitle_unit': 'шаблонов',
  'templates.list_title': 'Каталог шаблонов',
  'templates.editor_title': 'Редактор шаблона',
  'templates.editor_empty': 'Выберите шаблон в таблице, чтобы изменить текст и переменные.',
  'templates.new_template': '6 шаблонов из seed доступны для редактирования.',
  'templates.new': 'Новый шаблон',
  'templates.name': 'Название',
  'templates.channel_label': 'Канал',
  'templates.search_label': 'Поиск шаблонов',
  'templates.search_placeholder': 'Поиск по названию, теме или тексту',
  'templates.refresh': 'Обновить шаблоны',
  'templates.reset_filters': 'Сбросить',
  'templates.new_body': 'Текст нового шаблона',
  'templates.create_submit': 'Создать шаблон',
  'templates.create_description':
    'Создайте новый шаблон для email, SMS или сообщений в приложении.',
  'templates.loading': 'Загрузка шаблонов...',
  'templates.load_error': 'Не удалось загрузить шаблоны',
  'templates.load_error_description': 'Проверьте соединение и попробуйте повторить запрос.',
  'templates.retry': 'Повторить',
  'templates.empty': 'Шаблонов пока нет. Создайте первый шаблон для быстрых сообщений.',
  'templates.empty_filtered': 'Нет шаблонов по текущим фильтрам.',
  'templates.save': 'Сохранить',
  'templates.open': 'Открыть',
  'templates.subject': 'Тема',
  'templates.body': 'Текст',
  'templates.no_preview': 'Без темы или текста',
  'templates.no_variables': 'Без переменных',
  'templates.variables': 'Переменные',
  'templates.usage_count': 'Использований',
  'templates.channel_filter_label': 'Канал:',
  'templates.name_placeholder': 'Название шаблона',
  'templates.channel.email': 'Email',
  'templates.channel.sms': 'SMS',
  'templates.channel.in_app': 'В приложении',
  'templates.filter.all': 'Все',
  'templates.summary.total': 'Всего шаблонов',
  'templates.summary.email': 'Email',
  'templates.summary.sms': 'SMS',
  'templates.summary.in_app': 'В приложении',
  'templates.table.template': 'Шаблон',
  'templates.table.action': 'Действие',
  'templates.editor.usage_count': 'Использований {count}',
  'templates.editor.variables_count_one': '{count} переменная',
  'templates.editor.variables_count_few': '{count} переменные',
  'templates.editor.variables_count_many': '{count} переменных',

  // Hot leads Week 5.
  'hot_leads.title': 'Горячие лиды',
  'hot_leads.subtitle': 'Сделки, которым нужно внимание прямо сейчас.',
  'hot_leads.table_title': 'Приоритетные сделки',
  'hot_leads.table_description':
    'Эвристика на основе активности, ближайших действий и суммы сделки.',
  'hot_leads.table_header.deal': 'Сделка',
  'hot_leads.table_header.contact': 'Контакт',
  'hot_leads.table_header.stage': 'Стадия',
  'hot_leads.table_header.reason': 'Причина',
  'hot_leads.table_header.action': 'Действие',
  'hot_leads.loading': 'Считаем горячие лиды...',
  'hot_leads.no_contact': 'Без контакта',
  'hot_leads.filter.all': 'Все',
  'hot_leads.filter.stale': 'без активности',
  'hot_leads.filter.due': 'ближайшие действия',
  'hot_leads.filter.high_value': 'высокая сумма',
  'hot_leads.filter.overdue_next_activity': 'просроченное действие',
  'hot_leads.filter.missing_next_activity': 'нет следующего действия',
  'hot_leads.filter.stale_activity': 'нет активности',
  'hot_leads.filter.overdue_task': 'просроченная задача',
  'hot_leads.reason.stale': 'без активности 4 дня',
  'hot_leads.reason.due': 'действие скоро',
  'hot_leads.reason.high_value': 'высокая сумма',
  'hot_leads.open_ai': 'Открыть в AI-чате',
  'hot_leads.recovery_title': 'Горячие лиды',
  'hot_leads.visible_count': '{visible} из {total} сделок требуют внимания',
  'hot_leads.table_header.amount': 'Сумма',
  'hot_leads.table_header.score': 'Приоритет',
  'hot_leads.table_header.recommendation': 'Следующий шаг',
  'hot_leads.reason.overdue_next_activity': 'следующее действие просрочено',
  'hot_leads.reason.missing_next_activity': 'нет следующего действия',
  'hot_leads.reason.stale_activity': 'нет новой активности',
  'hot_leads.reason.overdue_task': 'есть просроченная задача',
  'hot_leads.recommendation.email': 'Подготовить письмо',
  'hot_leads.recommendation.call': 'Связаться с клиентом',
  'hot_leads.open_recovery': 'Разобрать',
  'hot_leads.refresh': 'Обновить очередь',
  'hot_leads.search_label': 'Поиск в очереди восстановления',
  'hot_leads.search_placeholder': 'Поиск по сделке или контакту',
  'hot_leads.reason_filter': 'Фильтр по причине',
  'hot_leads.stage_filter': 'Фильтр по стадии',
  'hot_leads.all_stages': 'Все стадии',
  'hot_leads.empty': 'Нет сделок, требующих восстановления по текущим фильтрам.',
  'hot_leads.load_error': 'Не удалось загрузить горячие лиды',
  'hot_leads.table_header.win_probability': 'Вероятность',

  // Win probability (conversion package BP-3): heuristic on-read scoring.
  'win_probability.title': 'Вероятность победы',
  'win_probability.factors': 'Главные факторы',
  'win_probability.factor.recent_engagement': {
    one: '{count} активное касание за последние {days} дн.',
    few: '{count} активных касания за последние {days} дн.',
    many: '{count} активных касаний за последние {days} дн.',
    other: '{count} активных касаний за последние {days} дн.',
  },
  'win_probability.factor.amount_above_median': 'Сумма не ниже медианы ({ratio}×)',
  'win_probability.factor.amount_below_median': 'Сумма заметно ниже медианы ({ratio}×)',
  'win_probability.factor.no_risk_signals': 'Явных сигналов риска нет',

  // Next best action (NBA shock package): one recommendation per deal.
  'features.deals.nextBestAction.title.schedule_activity': 'Запланировать следующий шаг',
  'features.deals.nextBestAction.title.complete_overdue_tasks': 'Закрыть просроченные задачи',
  'features.deals.nextBestAction.title.log_touch': 'Зафиксировать касание',
  'features.deals.nextBestAction.title.fill_qualification': 'Заполнить квалификацию',
  'features.deals.nextBestAction.title.advance_stage': 'Продвинуть сделку',
  'features.deals.nextBestAction.reason.next_activity_missing': 'Следующий шаг не запланирован',
  'features.deals.nextBestAction.reason.next_activity_overdue':
    'Следующий шаг просрочен на {days} дн.',
  'features.deals.nextBestAction.reason.overdue_tasks': 'Просроченных задач: {count}',
  'features.deals.nextBestAction.reason.stale_activity': 'Нет новых касаний {days} дн.',
  'features.deals.nextBestAction.reason.qualification_gaps':
    'Не подтверждено {gaps} из {total} пунктов квалификации',
  'features.deals.nextBestAction.reason.stage_age_over_norm':
    'Сделка на стадии «{stage}» уже {days} дн. при норме {norm} дн.',
  // Attention queue (batch 4): pipeline-wide "money at risk" digest. The reason
  // chips reuse the engine codes, but the queue carries no params, so these are
  // the short param-free labels instead of the `reason.*` sentences above.
  'features.deals.nextBestAction.queue.title': 'Деньги под риском',
  'features.deals.nextBestAction.queue.open': 'Все сделки',
  'features.deals.nextBestAction.queue.score': 'Вероятность',
  'features.deals.nextBestAction.queue.amount_of': 'из {amount}',
  'features.deals.nextBestAction.queue.empty': 'В открытых сделках риска нет',
  'features.deals.nextBestAction.queue.empty_hint':
    'У всех открытых сделок есть следующий шаг и свежие касания.',
  'features.deals.nextBestAction.queue.error': 'Не удалось загрузить очередь внимания',
  'features.deals.nextBestAction.queue.retry': 'Повторить',
  'features.deals.nextBestAction.queue.row_aria': 'Сделка {title}: под риском {risk}',
  'features.deals.nextBestAction.queue.reason.next_activity_missing': 'Нет следующего шага',
  'features.deals.nextBestAction.queue.reason.next_activity_overdue': 'Шаг просрочен',
  'features.deals.nextBestAction.queue.reason.overdue_tasks': 'Просроченные задачи',
  'features.deals.nextBestAction.queue.reason.stale_activity': 'Нет касаний',
  'features.deals.nextBestAction.queue.reason.qualification_gaps': 'Пробелы в квалификации',
  'features.deals.nextBestAction.queue.reason.stage_age_over_norm': 'Застой на стадии',
  'features.deals.nextBestAction.confidence.label': 'Уверенность',
  'features.deals.nextBestAction.impact.label': 'Прогноз влияния',
  // «п.п.» — процентные пункты, сокращение не склоняется: все категории равны.
  'features.deals.nextBestAction.impact.points': {
    one: '+{count} п.п.',
    few: '+{count} п.п.',
    many: '+{count} п.п.',
    other: '+{count} п.п.',
  },
  'features.deals.nextBestAction.execute': 'Выполнить',
  'features.deals.nextBestAction.empty': 'Сейчас рекомендаций нет',
  'features.deals.nextBestAction.error.load': 'Не удалось загрузить рекомендацию',
  'features.deals.nextBestAction.error.execute': 'Не удалось выполнить действие',
  // Next-step card and what-if simulator (batch 2).
  'features.deals.nextBestAction.card.title': 'Следующий шаг',
  'features.deals.nextBestAction.loading': 'Считаем следующий шаг…',
  'features.deals.nextBestAction.score.current': 'Сейчас',
  'features.deals.nextBestAction.score.projected': 'После действия',
  'features.deals.nextBestAction.meta.overdueTasks': 'Просрочено задач: {count}',
  'features.deals.nextBestAction.meta.targetStage': 'Целевая стадия: {stage}',
  'features.deals.nextBestAction.preview.title': 'Что произойдёт',
  'features.deals.nextBestAction.preview.effect.schedule_activity':
    'Создадим задачу на ближайшие дни и назначим её следующим шагом сделки.',
  'features.deals.nextBestAction.preview.effect.complete_overdue_tasks':
    'Закроем все просроченные задачи сделки одной операцией.',
  'features.deals.nextBestAction.preview.effect.log_touch':
    'Зафиксируем касание и обновим дату последней активности.',
  'features.deals.nextBestAction.preview.effect.fill_qualification':
    'Откроем карточку, чтобы подтвердить пункты квалификации.',
  'features.deals.nextBestAction.preview.effect.advance_stage':
    'Переведём сделку на следующую стадию.',
  'features.deals.nextBestAction.result.done': 'Готово. Вероятность: {before}% → {after}%',
  'features.deals.nextBestAction.simulator.title': 'Что если',
  'features.deals.nextBestAction.simulator.hint':
    'Это только прогноз: в сделке ничего не изменится, пока шаг не выполнен.',
  'features.deals.nextBestAction.simulator.type': 'Действие',
  'features.deals.nextBestAction.simulator.error': 'Не удалось рассчитать прогноз',
  'features.deals.nextBestAction.empty.hint': 'Все сигналы в норме — сделку можно двигать дальше.',
  'features.deals.nextBestAction.navigate.stage': 'Перейти к смене стадии',
  'features.deals.nextBestAction.navigate.qualification': 'Открыть квалификацию',
  'features.deals.nextBestAction.task.schedule': 'Следующий шаг по сделке',
  'features.deals.nextBestAction.touch.subject': 'Касание из карточки сделки',

  // Approvals Week 5.
  'approvals.approve': 'Подтвердить',
  'approvals.reject': 'Отклонить',
  'approvals.pending': 'Ожидает подтверждения',
  'approvals.approved': 'Подтверждено',
  'approvals.rejected': 'Отклонено',
  'approvals.expired': 'Срок истёк',
  'approvals.cancelled': 'Отменено',
  'approvals.expires_at': 'Истекает:',
  'approvals.execution_result': 'Результат выполнения',
  'approvals.execution_failed': 'Действие не выполнено',
  'approvals.execution_failed_details':
    'Подтверждение сохранено, но запрошенное действие выполнить не удалось.',
  'approvals.execution_executing': 'Выполняется',
  'approvals.execution_succeeded': 'Выполнено',
  'approvals.execution_pending_verification': 'Результат проверяется',
  'approvals.consistency.title': 'Проверьте данные: сообщение и действие расходятся',
  'approvals.consistency.missing':
    '«{field}»: в сообщении указано «{expected}», но в действии поле не заполнено',
  'approvals.consistency.mismatch':
    '«{field}»: в сообщении «{expected}», а в действии — «{actual}»',
  'approvals.execution_stale': 'Стадия уже изменилась',
  'approvals.execution_stale_details':
    'Стадия сделки изменилась после подготовки. Создайте новое подтверждение.',
  'approvals.execution_stale_write': 'Запись уже изменилась',
  'approvals.execution_stale_write_details':
    'Запись изменилась после подготовки подтверждения. Подготовьте действие заново и повторите попытку.',
  'approvals.detail.memory_key': 'Ключ',
  'approvals.detail.memory_level': 'Уровень памяти',
  'approvals.detail.memory_value': 'Факт',
  'approvals.detail.memory_importance': 'Важность',
  'approvals.detail.memory_embedding': 'Семантический поиск',
  'approvals.detail.memory_embedding_requested':
    'Текст будет отправлен AI-провайдеру для создания embedding. Результат проверяется отдельно.',
  'approvals.summary.generic': 'Подтвердите запрошенное действие',
  'approvals.summary.create_deal': 'Создать сделку',
  'approvals.summary.update_deal': 'Изменить сделку',
  'approvals.summary.delete_deal': 'Удалить сделку',
  'approvals.summary.add_deal_note': 'Добавить заметку к сделке',
  'approvals.summary.update_deal_stage': 'Изменить стадию сделки',
  'approvals.summary.create_deal_tasks': 'Создать задачи по сделке',
  'approvals.summary.update_deal_qualification': 'Обновить квалификацию сделки',
  'approvals.summary.send_email': 'Отправить подготовленное письмо',
  'approvals.summary.enrich_contact': 'Дополнить данные контакта',
  'approvals.summary.run_scenario': 'Запустить сценарий',
  'approvals.summary.write_memory': 'Сохранить информацию в памяти AI',
  'approvals.summary.update_memory': 'Изменить информацию в памяти AI',
  'approvals.summary.delete_memory': 'Удалить информацию из памяти AI',
  'approvals.summary.execute_import': 'Запустить проверенный импорт',
  'approvals.summary.document_to_note': 'Создать заметку из документа',
  'approvals.summary.conversation_to_note': 'Сохранить переписку в заметку',
  'approvals.summary.refresh_entity_context': 'Обновить контекст записи',
  'approvals.summary.generate_dashboard_widget': 'Создать виджет дашборда',
  'approvals.summary.create_text_attachment': 'Создать текстовое вложение',
  'approvals.summary.update_text_attachment': 'Изменить текстовое вложение',
  'approvals.summary.create_task': 'Создать задачу',
  'approvals.summary.update_task': 'Изменить задачу',
  'approvals.summary.delete_task': 'Удалить задачу',
  'approvals.summary.set_task_status': 'Изменить статус задачи',
  'approvals.summary.assign_task': 'Назначить исполнителя задачи',
  'approvals.summary.link_task': 'Привязать задачу к записи',
  'approvals.summary.unlink_task': 'Удалить связь задачи',
  'approvals.summary.set_task_due_date': 'Изменить срок задачи',
  'approvals.summary.create_note': 'Создать заметку',
  'approvals.summary.update_note': 'Изменить заметку',
  'approvals.summary.delete_note': 'Удалить заметку',
  'approvals.summary.link_note': 'Привязать заметку к записи',
  'approvals.summary.unlink_note': 'Удалить связь заметки',
  'approvals.summary.create_contact': 'Создать контакт',
  'approvals.summary.update_contact': 'Изменить контакт',
  'approvals.summary.delete_contact': 'Удалить контакт',
  'approvals.summary.set_contact_tags': 'Изменить теги контакта',
  'approvals.summary.set_contact_owner': 'Изменить ответственного за контакт',
  'approvals.summary.link_contact_company': 'Привязать контакт к компании',
  'approvals.summary.unlink_contact_company': 'Отвязать контакт от компании',
  'approvals.summary.create_contact_interaction': 'Записать взаимодействие с контактом',
  'approvals.summary.update_contact_interaction': 'Изменить взаимодействие с контактом',
  'approvals.summary.delete_contact_interaction': 'Удалить взаимодействие с контактом',
  'approvals.summary.create_company': 'Создать компанию',
  'approvals.summary.update_company': 'Изменить компанию',
  'approvals.summary.delete_company': 'Удалить компанию',
  'approvals.summary.create_project': 'Создать проект',
  'approvals.summary.add_project_member': 'Добавить участника проекта',
  'approvals.summary.remove_project_member': 'Удалить участника проекта',
  'approvals.summary.update_project': 'Изменить проект',
  'approvals.summary.delete_project': 'Удалить проект',
  'approvals.summary.set_company_tags': 'Изменить теги компании',
  'approvals.summary.set_company_owner': 'Изменить ответственного за компанию',
  'approvals.summary.link_company_relation': 'Привязать запись к компании',
  'approvals.summary.unlink_company_relation': 'Отвязать запись от компании',
  'approvals.detail.name': 'Название',
  'approvals.detail.first_name': 'Имя',
  'approvals.detail.last_name': 'Фамилия',
  'approvals.detail.phone': 'Телефон',
  'approvals.detail.email': 'Email',
  'approvals.detail.role': 'Роль',
  'approvals.detail.company': 'Компания',
  'approvals.detail.member': 'Участник',
  'approvals.detail.interaction_type': 'Тип взаимодействия',
  'approvals.impact.label': 'Затронутые записи',
  'approvals.impact.contacts': 'контакты: {count}',
  'approvals.impact.deals': 'сделки: {count}',
  'approvals.impact.tasks': 'задачи: {count}',
  'approvals.impact.documents': 'документы: {count}',
  'approvals.impact.interactions': 'взаимодействия: {count}',
  'approvals.impact.notes': 'записи заметок: {count}',
  'approvals.impact.calendarEvents': 'записи встреч: {count}',
  'approvals.impact.calendarParticipants': 'связи участников встреч: {count}',
  'approvals.impact.noteLinks': 'связи заметок: {count}',
  'approvals.impact.attachments': 'записи вложений: {count}',
  'approvals.impact.projectMembers': 'участники проекта: {count}',
  'approvals.detail.title': 'Название',
  'approvals.detail.deal': 'Сделка',
  'approvals.scenario_step.follow_up.action': 'Отправить follow-up письмо',
  'approvals.scenario_step.follow_up.recipient': 'Получатель',
  'approvals.scenario_step.follow_up.subject': 'Тема',
  'approvals.scenario_step.workflow.action': 'Подтвердить шаг сценария',
  'approvals.scenario_step.workflow.step': 'Шаг сценария',
  'approvals.scenario_step.workflow.requires': 'Требует подтверждения перед выполнением',
  'approvals.scenario_step.workflow.requires_destructive': 'Опасное действие',
  'approvals.scenario_step.workflow_email.action': 'Подтвердить отправку письма',
  'approvals.scenario_step.workflow_email.recipient': 'Получатель',
  'approvals.scenario_step.workflow_email.subject': 'Тема',
  'approvals.scenario_step.workflow_email.body': 'Текст письма',
  'approvals.detail.stage': 'Новая стадия',
  'approvals.detail.from_stage': 'Было',
  'approvals.detail.to_stage': 'Будет',
  'approvals.detail.stage_transition': 'Было: {fromStage} → Будет: {toStage}',
  'approvals.detail.subject': 'Тема',
  'approvals.detail.recipient': 'Получатель',
  'approvals.detail.memory': 'Ключ памяти',
  'approvals.detail.scenario': 'Сценарий',
  'approvals.detail.contact': 'Контакт',
  'approvals.detail.actions': 'Действий: {count}',
  'approvals.detail.status': 'Статус',
  'approvals.detail.priority': 'Приоритет',
  'approvals.detail.due_at': 'Срок',
  'approvals.detail.start_date': 'Дата начала',
  'approvals.detail.due_date': 'Срок',
  'approvals.detail.assignee': 'Исполнитель',
  'approvals.detail.owner': 'Владелец',
  'approvals.detail.project': 'Проект',
  'approvals.detail.task': 'Задача',
  'approvals.detail.document': 'Документ',
  'approvals.detail.link': 'Связь',
  'approvals.detail.file_name': 'Файл',
  'approvals.detail.entity_type': 'Тип сущности',
  'approvals.detail.rows': 'Строки',
  'approvals.detail.review': 'Проверьте действие перед подтверждением.',
  'approvals.detail.from': 'Было',
  'approvals.detail.to': 'Будет',
  'approvals.detail.reason': 'Причина',
  'approvals.detail.description': 'Описание',
  'approvals.detail.source': 'Источник',
  'approvals.detail.tags': 'Теги',
  'approvals.detail.name_unavailable': 'Название недоступно',
  'approvals.detail.field_changed': 'Изменённое поле',
  'approvals.detail.domain': 'Домен',
  'approvals.detail.industry': 'Отрасль',
  'approvals.detail.website': 'Сайт',
  'approvals.bulk.summary.create_deals': 'Массово создать сделки',
  'approvals.bulk.summary.update_deals': 'Массово изменить сделки',
  'approvals.bulk.summary.delete_deals': 'Массово удалить сделки',
  'approvals.bulk.summary.set_deal_stage': 'Массово изменить стадии сделок',
  'approvals.bulk.summary.set_deal_owner': 'Массово изменить ответственных по сделкам',
  'approvals.bulk.summary.set_deal_tags': 'Массово изменить теги сделок',
  'approvals.bulk.summary.create_tasks': 'Массово создать задачи',
  'approvals.bulk.summary.update_tasks': 'Массово изменить задачи',
  'approvals.bulk.summary.delete_tasks': 'Массово удалить задачи',
  'approvals.bulk.summary.set_task_status': 'Массово изменить статусы задач',
  'approvals.bulk.summary.set_task_assignee': 'Массово изменить исполнителей задач',
  'approvals.bulk.summary.set_task_due_date': 'Массово изменить сроки задач',
  'approvals.bulk.summary.create_notes': 'Массово создать заметки',
  'approvals.bulk.summary.update_notes': 'Массово изменить заметки',
  'approvals.bulk.summary.delete_notes': 'Массово удалить заметки',
  'approvals.bulk.summary.link_notes': 'Массово привязать заметки к записям',
  'approvals.bulk.summary.unlink_notes': 'Массово удалить связи заметок',
  'approvals.bulk.summary.create_contacts': 'Массово создать контакты',
  'approvals.bulk.summary.update_contacts': 'Массово изменить контакты',
  'approvals.bulk.summary.delete_contacts': 'Массово удалить контакты',
  'approvals.bulk.summary.set_contact_tags': 'Массово изменить теги контактов',
  'approvals.bulk.summary.set_contact_owner': 'Массово изменить ответственных за контакты',
  'approvals.bulk.summary.link_contact_company': 'Массово привязать контакты к компании',
  'approvals.bulk.summary.unlink_contact_company': 'Массово отвязать контакты от компании',
  'approvals.bulk.summary.create_companies': 'Массово создать компании',
  'approvals.bulk.summary.update_companies': 'Массово изменить компании',
  'approvals.bulk.summary.delete_companies': 'Массово удалить компании',
  'approvals.bulk.summary.set_company_tags': 'Массово изменить теги компаний',
  'approvals.bulk.summary.set_company_owner': 'Массово изменить ответственных за компании',
  'approvals.bulk.summary.link_companies': 'Массово привязать записи к компаниям',
  'approvals.bulk.summary.unlink_companies': 'Массово отвязать записи от компаний',
  'approvals.bulk.review_count': 'Проверьте {count} записей перед подтверждением.',
  'approvals.bulk.field.amount': 'Сумма',
  'approvals.bulk.assignee.change': 'Назначить нового исполнителя',
  'approvals.bulk.assignee.remove': 'Снять исполнителя',
  'approvals.bulk.count': 'Выбрано записей: {count}',
  'approvals.bulk.partial_semantics':
    'Каждая запись сохраняется независимо: часть операций может завершиться, а часть — нет.',
  'approvals.bulk.excluded': 'Исключено проверками безопасности: {count}',
  'approvals.bulk.relation_type': 'Тип связанной записи: {relationType}',
  'approvals.bulk.relation.deal': 'сделка',
  'approvals.bulk.relation.company': 'компания',
  'approvals.bulk.relation.contact': 'контакт',
  'approvals.bulk.relation.task': 'задача',
  'approvals.bulk.relation.calendar_event': 'встреча',
  'approvals.bulk.relation.document': 'документ',
  'approvals.bulk.relation.template': 'шаблон',
  'approvals.bulk.relation.mixed': 'разные типы записей',
  'approvals.bulk.item': 'Запись {number}',
  'approvals.bulk.sample_capped': 'Показано до {count} записей; ещё {remaining}.',
  'approvals.bulk.result':
    'Выполнено: {succeeded} · Ошибки: {failed} · Устарело: {stale} · Пропущено: {skipped} · Выполняется: {unfinished}',
  'approvals.bulk.delete_warning':
    'Будет удалено записей: {count}. Перед продолжением проверьте точное количество.',
  'approvals.bulk.confirm_delete': 'Удалить {count}',
  'approvals.bulk.status.partial': 'Выполнено частично',
  'approvals.bulk.status.retry': 'Подготовьте заново',
  'approvals.bulk.retry_details':
    'Надёжная попытка безопасно завершена. Перед повтором проверьте новое подтверждение.',
  'approvals.bulk.item_status.pending': 'Ожидает',
  'approvals.bulk.item_status.executing': 'Выполняется',
  'approvals.bulk.item_status.succeeded': 'Выполнено',
  'approvals.bulk.item_status.failed': 'Ошибка',
  'approvals.bulk.item_status.stale': 'Запись изменилась',
  'approvals.bulk.item_status.skipped': 'Пропущено',

  // Deal card Week 6.
  'deal_card.loading': 'Загрузка сделки...',
  'deal_card.retry': 'Повторить',
  'deal_card.error_title': 'Не удалось загрузить сделку',
  'deal_card.error_retry': 'Попробуйте обновить страницу.',
  'deal_card.back_to_deals': 'К сделкам',
  'deal_card.sections_label': 'Разделы сделки',
  'deal_card.tabs.details': 'Детали',
  'deal_card.tabs.activity': 'Активность',
  'deal_card.tabs.notes': 'Заметки',
  'deal_card.tabs.tasks': 'Задачи',
  'deal_card.tabs.chat': 'Чат',
  'deal_card.summary.amount': 'Сумма',
  'deal_card.summary.contact': 'Контакт',
  'deal_card.summary.source': 'Источник',
  'deal_card.summary.activity_count': 'Активности',
  'deal_card.summary.next_step': 'Следующий контакт',
  'deal_card.summary.owner': 'Ответственный',
  'deal_card.activity_count': {
    one: '{count} активность',
    few: '{count} активности',
    many: '{count} активностей',
    other: '{count} активностей',
  },
  'deal_card.details_title': 'Детали сделки',
  'deal_card.details.contact': 'Контакт',
  'deal_card.details.contact_missing': 'Контакт не указан',
  'deal_card.details.source': 'Источник:',
  'deal_card.details.source_missing': 'Не указан',
  'deal_card.details.next_activity': 'Следующий контакт',
  'deal_card.details.next_activity_missing': 'Не назначен',
  'deal_card.form.title': 'Название сделки',
  'deal_card.form.amount': 'Сумма',
  'deal_card.form.source': 'Источник',
  'deal_card.form.next_activity': 'Следующий контакт',
  'deal_card.details_save': 'Сохранить детали',
  'deal_card.activity_title': 'Последние активности',
  'deal_card.notes_title': 'Заметки',
  'deal_card.notes_placeholder': 'Редактор заметок подключим на следующем шаге.',
  'deal_card.notes_empty': 'Заметок пока нет.',
  'deal_card.note_new_label': 'Новая заметка',
  'deal_card.note_placeholder': 'Что важно помнить перед следующим контактом?',
  'deal_card.note_save': 'Сохранить заметку',
  'deal_card.note_subject_fallback': 'Заметка',
  'deal_card.quick_add_note': 'Добавить заметку',
  'deal_card.chat_title': 'Чат',
  'deal_card.chat_desktop_note': 'AI-чат открывается в боковой панели.',
  'deal_card.chat_mobile_title': 'AI-чат',
  'deal_card.open_chat': 'Открыть AI-чат',
  'chat.conversations': 'Диалоги',
  'chat.new_conversation': 'Новый диалог',
  'chat.settings': 'Настройки',
  'chat.open_chat': 'Открыть AI-чат',
  'chat.drawer_title': 'AI-чат',
  'chat.active_model.neuraldeep': 'NeuralDeep',
  'chat.active_model.openrouter': 'OpenRouter · {model}',
  'ai_chat.route.used': 'Использовано: {provider} · {model} · trace {trace}',
  'ai_chat.route.requested': 'Запрошено: {provider} · {model}',
  'ai_chat.route.provider.opencode': 'OpenCode Zen',
  'ai_chat.route.provider.govard': 'Govard',
  'ai_chat.route.provider.openrouter': 'OpenRouter',
  'ai_chat.route.provider.neuraldeep': 'NeuralDeep',
  'ai_chat.route.provider.anthropic': 'Anthropic',
  'ai_chat.route.provider.stub': 'Тестовый шлюз',
  'approvals.undo': 'Отменить',
  'approvals.detail.undo_context': 'Контекст',
  'approvals.undo_creation_context': 'Отмена создания задачи',
  'approvals.undo_created_task_label': 'Отменить создание задачи',
  'approvals.undo_state.unavailable':
    'Не удалось найти доступное подтверждение создания задачи в этом чате.',
  'approvals.undo_state.pending': 'Отмена уже запрошена и ждёт подтверждения.',
  'approvals.undo_state.executing': 'Отмена уже подтверждена и выполняется.',
  'approvals.undo_state.succeeded': 'Задача уже удалена.',
  'approvals.undo_state.rejected':
    'Отмена была отклонена. При необходимости удалите задачу вручную на странице задач.',
  'approvals.undo_state.expired':
    'Срок подтверждения отмены истёк. Удалите задачу вручную на странице задач.',
  'approvals.undo_state.failed':
    'Отмена не выполнена; задача могла быть изменена. Проверьте её на странице задач.',
  'approvals.undo_state.cancelled':
    'Отмена была отменена. При необходимости удалите задачу вручную на странице задач.',
  'approvals.undo_state.completed': 'Задача уже завершена; отмена создания не выполнена.',
  'approvals.undo_state.stale':
    'Задача была изменена после создания; отмена создания не выполнена. Проверьте её на странице задач.',
  'approvals.undo_create_task_prompt':
    'Подготовь удаление задачи «{title}» (taskId: {taskId}, expectedUpdatedAt: {expectedUpdatedAt}). Сначала покажи отдельное подтверждение удаления.',
  'deal_card.chat_mobile_description': 'Чат открыт в мобильном focus-режиме для текущей сделки.',
  'deal_card.owner_title': 'Ответственный',
  'deal_card.owner_label': 'Ответственный',
  'deal_card.owner_missing': 'Не назначен',
  'deal_card.close_chat': 'Закрыть',

  // Dashboard Week 7/8 onboarding.
  'dashboard.onboarding.title': 'Настройка CRM',
  'dashboard.onboarding.welcome_title': 'Добро пожаловать в GovardOS',
  'dashboard.onboarding.welcome_hint':
    'Настроим CRM и запустим первую сделку в работу. Завершите эти шаги, чтобы раскрыть весь потенциал.',
  'dashboard.onboarding.progress_label': 'Прогресс',
  'dashboard.onboarding.first_deal': 'Первая сделка',
  'dashboard.onboarding.client_contacted': 'Контакт с клиентом',
  'dashboard.onboarding.deal_won': 'Успешная сделка',
  'dashboard.onboarding.dismiss': 'Скрыть',

  // Dashboard Week 7.
  'dashboard.loading': 'Обновляем ключевые метрики...',
  'dashboard.kpi.projects': 'Проекты',
  'dashboard.kpi.projects_hint': 'Сущности портфеля',
  'dashboard.kpi.active': 'Активные',
  'dashboard.kpi.active_hint': 'Открытые сделки в воронке',
  'dashboard.kpi.tasks_done': 'Выполнено задач',
  'dashboard.kpi.tasks_done_hint': 'По плану и всего',
  'dashboard.kpi.sessions': 'Сессии',
  'dashboard.kpi.sessions_hint': 'Запущенные сценарии',
  'dashboard.kpi.success_rate': 'Доля успеха',
  'dashboard.kpi.success_rate_hint': 'Завершённые сценарии',
  'dashboard.kpi.total_cost': 'Общие расходы',
  'dashboard.kpi.total_cost_hint': 'Шаблоны и нагрузка',
  'dashboard.kpi.vs_last_period': 'к прошлому периоду',
  'dashboard.kpi.section_label': 'Ключевые показатели',
  'dashboard.kpi.this_week': 'за неделю',
  'dashboard.kpi.created_recently': 'новых за период',
  'dashboard.status.active': 'Активно',
  'dashboard.status.running': 'В работе',
  'dashboard.status.completed': 'Завершено',
  'dashboard.status.done': 'Готово',
  'dashboard.status.paused': 'Пауза',
  'dashboard.status.blocked': 'Заблокировано',
  'dashboard.status.failed': 'Ошибка',
  'dashboard.status.cancelled': 'Отменено',
  'dashboard.status.offline': 'Офлайн',
  'dashboard.status.backlog': 'Бэклог',
  'dashboard.status.todo': 'К выполнению',
  'dashboard.status.pending': 'Ожидание',
  'dashboard.status.in_progress': 'В процессе',
  'dashboard.workforce.active': '{count} активно',

  // Chat Week 6.
  'chat.title': 'AI Chat',
  'chat.ready': 'Готов',
  'chat.context_hint':
    'Ассистент видит текущую сделку, контакт, активность и может подготовить следующий шаг.',
  'chat.suggestions_title': 'Быстрые сценарии',
  'chat.suggestion_next_step': 'Предложить следующий шаг',
  'chat.suggestion_next_step_prompt':
    'Проанализируй текущую сделку {dealId} и предложи один лучший следующий шаг с коротким обоснованием.',
  'chat.suggestion_risks': 'Найти риск потери сделки',
  'chat.suggestion_risks_prompt':
    'Проанализируй риск потери по текущей сделке {dealId}. Вызови analyze_deal_risk, покажи найденные сигналы и рекомендуемый follow-up. Не создавай задачу, не меняй стадию и не отправляй письмо.',
  'chat.suggestion_action_plan': 'Составить план действий',
  'chat.suggestion_action_plan_prompt':
    'Составь план действий по текущей сделке {dealId}: предложи от 1 до 5 конкретных действий с приоритетом, сроком и кратким обоснованием. Пока только покажи план, не создавай задачи.',
  'chat.suggestion_cockpit': 'Показать Deal Cockpit',
  'chat.suggestion_cockpit_prompt':
    'Покажи состояние текущей сделки {dealId} в виде Deal Cockpit. Вызови get_deal_cockpit. Это только read-only обзор: не меняй сделки, задачи и письма.',
  'chat.placeholder': 'Спросите ассистента о сделке...',
  'chat.send': 'Отправить',
  'chat.deal_summary.amount': 'Сумма',
  'chat.deal_summary.source': 'Источник',
  'chat.deal_summary.source_missing': 'Не указан',
  'chat.deal_summary.contact': 'Контакт',
  'chat.deal_summary.contact_missing': 'Контакт не указан',
  'chat.deal_summary.next_activity': 'Следующая активность',
  'chat.deal_summary.next_activity_missing': 'Не запланирована',
  'chat.deal_summary.last_activity': 'Последняя активность',
  'chat.deal_summary.last_activity_missing': 'Нет данных',
  'chat.deal_summary.activities': 'Последние события',
  'chat.deal_summary.activities_empty': 'Событий пока нет',
  'chat.deal_cockpit.health_label': 'Состояние сделки',
  'chat.deal_cockpit.health.low': 'Стабильная',
  'chat.deal_cockpit.health.medium': 'Требует внимания',
  'chat.deal_cockpit.health.high': 'Высокий риск',
  'chat.deal_cockpit.signals_found': 'Сигналов риска: {count}',
  'chat.deal_cockpit.amount': 'Сумма',
  'chat.deal_cockpit.open_tasks': 'Открытые задачи',
  'chat.deal_cockpit.overdue': 'Просрочено',
  'chat.deal_cockpit.contact': 'Контакт',
  'chat.deal_cockpit.contact_missing': 'Контакт не указан',
  'chat.deal_cockpit.next_activity': 'Следующая активность',
  'chat.deal_cockpit.last_activity': 'Последняя активность',
  'chat.deal_cockpit.not_scheduled': 'Не запланирована',
  'chat.deal_cockpit.no_activity': 'Нет данных',
  'chat.deal_cockpit.risk_signals': 'Сигналы риска',
  'chat.deal_cockpit.qualification_title': 'Квалификация',
  'chat.deal_cockpit.qualification_field.need': 'Потребность',
  'chat.deal_cockpit.qualification_field.budget': 'Бюджет',
  'chat.deal_cockpit.qualification_field.decisionMaker': 'ЛПР',
  'chat.deal_cockpit.qualification_field.decisionDeadline': 'Срок решения',
  'chat.deal_cockpit.qualification_field.selectionCriteria': 'Критерии выбора',
  'chat.deal_cockpit.next_best_action': 'Лучший следующий шаг',
  'chat.deal_cockpit.tasks': 'Задачи',
  'chat.deal_cockpit.tasks_empty': 'Открытых задач нет',
  'chat.deal_cockpit.read_only': 'Это только обзор. Данные CRM не изменялись.',
  'chat.deal_risk.badge': 'Риск сделки',
  'chat.deal_risk.signals': 'Сигналы риска',
  'chat.deal_risk.signal_count': {
    one: '{count} сигнал риска',
    few: '{count} сигнала риска',
    many: '{count} сигналов риска',
    other: '{count} сигналов риска',
  },
  'chat.deal_risk.signals_empty': 'Явных сигналов риска не найдено.',
  'chat.deal_risk.recommendation': 'Рекомендуемый следующий шаг',
  'chat.deal_risk.channel.email': 'Follow-up по email',
  'chat.deal_risk.channel.call': 'Связаться с клиентом',
  'chat.deal_risk.channel.none': 'Действие не требуется',
  'chat.deal_risk.read_only': 'Это только анализ. Сделка, задачи и письмо не были изменены.',
  'chat.deal_risk.prepare_follow_up': 'Подготовить follow-up',
  'chat.deal_risk.level.low': 'Низкий риск',
  'chat.deal_risk.level.medium': 'Средний риск',
  'chat.deal_risk.level.high': 'Высокий риск',
  'chat.deal_risk.carousel_title': 'Анализ рисков по сделкам',
  'chat.deal.carousel_title': 'Сделки',
  'chat.contact.carousel_title': 'Контакты',
  'chat.crm_list.title': 'Записи CRM: {entity}',
  'chat.crm_list.total': 'Всего найдено: {count}',
  'chat.crm_list.more_available': 'Есть ещё записи',
  'chat.crm_list.empty': 'По выбранным условиям ничего не найдено.',
  'chat.crm_list.source': 'Данные получены из проверенной выборки CRM.',
  'chat.crm_list.next_page': 'Следующая страница',
  'chat.crm_list.next_page_prompt': 'Загрузить следующую страницу этого списка',
  'chat.crm_list.next_page_source': 'Предыдущий список CRM',
  'chat.crm_list.column.name': 'Название',
  'chat.crm_list.filter_equals': '{field}: {value}',
  'chat.crm_list.filter_contains': '{field}: «{value}»',
  'chat.crm_list.filter_any_of': '{field}: любое из [{value}]',
  'chat.crm_list.filter_between': '{field}: {value}',
  'chat.crm_list.filter_gte': '{field}: от {value}',
  'chat.crm_list.filter_label': 'Фильтр',
  'chat.crm_list.window.today': 'сегодня и просроченные',
  'chat.crm_list.window.tomorrow': 'завтра',
  'chat.crm_list.window.week': 'эта неделя',
  'chat.crm_list.entity.default': 'записи CRM',
  'chat.crm_list.entity.deal': 'сделки',
  'chat.crm_list.entity.task': 'задачи',
  'chat.crm_list.entity.contact': 'контакты',
  'chat.crm_list.entity.company': 'компании',
  'chat.crm_list.entity.document': 'документы',
  'chat.crm_list.entity.calendar_event': 'события календаря',
  'chat.crm_list.entity.note': 'заметки',
  'chat.crm_list.entity.project': 'проекты',
  'ai_chat.task_selection.proposal_ready':
    'Предложение подготовлено. Проверьте задачи и подтвердите изменение в карточке. До подтверждения задачи не изменены.',
  'ai_chat.task_selection.proposal_failed':
    'Не удалось проверить выборку или заменить ожидающее предложение. Задачи этим запросом не изменены; обновите выборку перед новым предложением.',
  'chat.crm_list.field.title': 'Название',
  'chat.crm_list.field.query': 'Поиск',
  'chat.crm_list.field.stage': 'Этап',
  'chat.crm_list.field.amount': 'Сумма',
  'chat.crm_list.field.currency': 'Валюта',
  'chat.crm_list.field.email': 'Email',
  'chat.crm_list.field.phone': 'Телефон',
  'chat.crm_list.field.company': 'Компания',
  'chat.crm_list.field.domain': 'Домен',
  'chat.crm_list.field.industry': 'Отрасль',
  'chat.crm_list.field.status': 'Статус',
  'chat.crm_list.field.priority': 'Приоритет',
  'chat.crm_list.field.assignee': 'Исполнитель',
  'chat.crm_list.field.project': 'Проект',
  'chat.crm_list.field.contact': 'Контакт',
  'chat.crm_list.field.deal': 'Сделка',
  'chat.crm_list.field.document': 'Документ',
  'chat.crm_list.field.dueAt': 'Срок',
  'chat.crm_list.field.startsAt': 'Начало',
  'chat.crm_list.field.endsAt': 'Окончание',
  'chat.crm_list.field.type': 'Тип',
  'chat.crm_list.field.body': 'Текст',
  'chat.action_plan.badge': 'План действий',
  'chat.action_plan.stage': 'Стадия',
  'chat.action_plan.open_tasks': 'Открытые задачи',
  'chat.action_plan.notes': 'Последние заметки',
  'chat.action_plan.actions': 'Предлагаемые действия',
  'chat.action_plan.rationale': 'Почему',
  'chat.action_plan.due_at': 'Срок',
  'chat.action_plan.proposal_only':
    'Это пока только предложение. Создание задач потребует отдельного подтверждения.',
  'chat.action_plan.select': 'Выбрать действие',
  'chat.action_plan.create_tasks': 'Создать выбранные задачи',
  'chat.action_plan.manual_confirm':
    'Можно также написать в чат «подтверждаю план» — тогда approval будет создан для всех пунктов последнего плана.',
  'chat.action_plan.priority.low': 'Низкий',
  'chat.action_plan.priority.medium': 'Средний',
  'chat.action_plan.priority.high': 'Высокий',
  'chat.action_plan.priority.urgent': 'Срочный',
  'chat.email_draft.badge': 'Черновик письма',
  'chat.email_draft.template': 'Шаблон',
  'chat.email_draft.recipient': 'Получатель',
  'chat.email_draft.body': 'Текст письма',
  'chat.email_draft.not_sent': 'Это черновик: письмо ещё не отправлено.',
  'chat.email_draft.send_for_approval': 'Запросить подтверждение отправки',
  'chat.email_draft.send_approval_command': 'Отправь черновик follow-up на согласование',
  'chat.usage': 'Стоимость последнего ответа: {cost} ₽',
  'chat.quick_follow_up': 'Написать follow-up',
  'chat.quick_follow_up_prompt':
    'Подготовь follow-up письмо для текущей сделки {dealId} через tool draft_email. Тон: warm. Верни черновик и не вызывай send_email.',
  'chat.crud_title': 'CRUD действия',
  'chat.crud_hint': 'Быстрые команды для заметки и смены стадии без ручного JSON.',
  'chat.crud_note_label': 'Текст заметки',
  'chat.crud_note_placeholder': 'Например: перезвонить завтра после 12:00',
  'chat.crud_add_note': 'Подготовить заметку',
  'chat.crud_stage_label': 'Новая стадия',
  'chat.crud_update_stage': 'Подготовить смену стадии',

  // System agent panel + `/chat` workspace.
  'system_agent.title': 'Системная панель',
  'system_agent.subtitle': 'Системный AI-контур CRM',
  'system_agent.close': 'Закрыть панель',
  'system_agent.description':
    'Быстрый доступ к системному AI workspace, последним сессиям и агентной панели.',
  'system_agent.open_chat': 'Открыть /chat',
  'system_agent.recent_sessions': 'Последние сессии',
  'system_agent.empty_sessions': 'Сессий пока нет',
  'chat_workspace.title': 'AI-рабочее пространство',
  'chat_workspace.heading': 'Рабочее пространство AI-агента',
  'chat_workspace.subtitle':
    'Демо-поверхность, где CRM-ассистент показывает ход работы: понимает запрос, вызывает tools, строит виджеты и просит подтверждение для действий.',
  'chat_workspace.sessions_title': 'Сессии workspace',
  'chat_workspace.sessions_description':
    'История системных AI-сессий текущего workspace; deal/contact контекст открывается через команды агента.',
  'chat_workspace.new_session': 'Новая системная сессия',
  'chat_workspace.new_session_title': 'Системная сессия',
  'chat_workspace.session_fallback': 'Системная сессия',
  'chat_workspace.empty_sessions': 'Создайте первую системную сессию',
  'chat_workspace.group.system': 'Система',
  'chat_workspace.group.workspace': 'Рабочее пространство',
  'chat_workspace.group.deals': 'Сделки',
  'chat_workspace.group.contacts': 'Контакты',
  'chat_workspace.context_global': 'глобальный контекст',
  'chat_workspace.context_unspecified': 'контекст не указан',
  'chat_workspace.visibility_private': 'приватная',
  'chat_workspace.visibility_shared': 'общая',
  'chat_workspace.current_session': 'Текущая сессия',
  'chat_workspace.system_session': 'системная',
  'chat_workspace.chat_title': 'Чат',
  'chat_workspace.chat_description':
    'Живой Ant Design X чат со streaming, structured output, snippets и approval-flow.',
  'chat_workspace.chat_placeholder': 'Напишите системному ассистенту...',
  'chat_workspace.chat_send': 'Отправить',
  'chat_workspace.cockpit_eyebrow': 'Агентная панель',
  'chat_workspace.cockpit_title': 'CRM-команда в одном чате',
  'chat_workspace.cockpit_description':
    'Быстрые демо-команды показывают, как агент ищет данные, анализирует риск, собирает план и готовит безопасные действия.',
  'chat_workspace.quick_actions_title': 'Демо-команды',
  'chat_workspace.agent_status_ready': 'Готов',
  'chat_workspace.agent_status_working': 'Работает',
  'chat_workspace.quick.hot_leads': 'Показать горячих лидов',
  'chat_workspace.quick.hot_leads_description':
    'Найти приоритетные возможности и объяснить следующий шаг.',
  'chat_workspace.quick.hot_leads_command': 'Горячие лиды',
  'chat_workspace.quick.hot_leads_prompt':
    'Покажи горячих лидов на сегодня, объясни почему они важны, и предложи следующий безопасный CRM-шаг.',
  'chat_workspace.quick.deal_risk': 'Оценить риск сделки',
  'chat_workspace.quick.deal_risk_description':
    'Показать демо анализа риска. Если ID сделки неизвестен, попроси пользователя выбрать сделку.',
  'chat_workspace.quick.deal_risk_command': 'Риск сделки',
  'chat_workspace.quick.deal_risk_prompt':
    'Покажи, как работает анализ риска сделки. Если в этом чате нет dealId, коротко попроси ID сделки и объясни, какой виджет риска ты построишь.',
  'chat_workspace.quick.action_plan': 'Собрать план действий',
  'chat_workspace.quick.action_plan_description':
    'Сформировать план следующих шагов и подготовить создание задач через approval.',
  'chat_workspace.quick.action_plan_command': 'План действий',
  'chat_workspace.quick.action_plan_prompt':
    'Составь короткий план действий по CRM-ситуации. Если нужен dealId, попроси его. Не создавай задачи без approval.',
  'chat_workspace.quick.workspace_view': 'Построить CRM-view',
  'chat_workspace.quick.workspace_view_description':
    'Сгенерировать таблицу или карточки из CRM-данных через show_view.',
  'chat_workspace.quick.workspace_view_command': 'CRM-view',
  'chat_workspace.quick.workspace_view_prompt':
    'Покажи полезное CRM-представление для менеджера: открытые сделки и задачи без следующего шага. Используй show_view, если данных достаточно, иначе задай один уточняющий вопрос.',
  'chat_workspace.workflow_title': 'Видимая агентная работа',
  'chat_workspace.workflow_intent': '1. Интент',
  'chat_workspace.workflow_intent_hint': 'Ассистент превращает свободный запрос в CRM-команду.',
  'chat_workspace.workflow_tools': '2. Инструменты',
  'chat_workspace.workflow_tools_hint':
    'Чтение выполняется сразу, изменения идут только через approval.',
  'chat_workspace.workflow_artifact': '3. Артефакт',
  'chat_workspace.workflow_artifact_hint':
    'Ответ приходит как карточка: risk, view, email draft, plan или memory.',
  'chat_workspace.workflow_approval': '4. Подтверждение',
  'chat_workspace.workflow_approval_hint':
    'Письма, задачи и CRUD-действия требуют подтверждения пользователя.',
  'chat_workspace.scenarios_title': 'База навыков (Skills)',
  'chat_workspace.scenarios_description':
    'Запускайте готовые CRM-навыки: поиск данных, оценка рисков, планирование задач.',
  'chat_workspace.llm_profile':
    'Модель: {endpoint} • Temp: {temperature} • Tokens: {maxTokens}. Данные защищены и не используются для обучения LLM.',
  'chat_workspace.executable_scenario_title': 'Сценарий удержания (Follow-up)',
  'chat_workspace.scenario_target_type': 'Тип цели',
  'chat_workspace.scenario_target_deal': 'Сделка',
  'chat_workspace.scenario_target_contact': 'Контакт',
  'chat_workspace.scenario_target_id': 'ID цели',
  'chat_workspace.scenario_target_id_placeholder': 'dealId или contactId',
  'chat_workspace.run_scenario': 'Выполнить с подтверждением',
  'chat_workspace.run_scenario_command_ref': 'Запуск сценария',
  'chat_workspace.playbook_title': 'Справочник сценариев (Playbooks)',
  'chat_workspace.playbook_select': 'Выбор CRM playbook',
  'chat_workspace.send_playbook': 'Инициализировать playbook',
  'chat_workspace.stage.discovery': 'discovery',
  'chat_workspace.stage.conversion': 'conversion',
  'chat_workspace.stage.retention': 'retention',
  'chat_workspace.stage.support': 'support',
  'chat_workspace.stage.orchestration': 'orchestration',

  // Memory Browser Week 7.
  'memory.title': 'Просмотр памяти',
  'memory.subtitle': 'Просмотр памяти агента по уровням L1/L2/L3 и семантический поиск L3.',
  'memory.browser_title': 'Память рабочего пространства',
  'memory.browser_description':
    'L1 — буфер сессии, L2 — эпизодическая память, L3 — векторные знания.',
  'memory.tabs_aria': 'Уровни памяти',
  'memory.search_label': 'Семантический поиск',
  'memory.search_placeholder': 'Например: лучшее время для связи',
  'memory.search_submit': 'Найти',
  'memory.search_loading': 'Ищем по памяти L3...',
  'memory.search_empty': 'По запросу «{query}» ничего не найдено.',
  'memory.search_error': 'Не удалось выполнить семантический поиск',
  'memory.search_unavailable': 'Семантический поиск пока недоступен',
  'memory.search_unavailable_hint': 'Провайдер эмбеддингов ещё не подключён в этом окружении.',
  'memory.score': 'Оценка: {score}',
  'memory.importance': 'Важность: {value}',
  'memory.empty': 'Записей пока нет.',
  'memory.load_error': 'Не удалось загрузить память',
  // Запись памяти заводит агент с подтверждением; вручную её можно только
  // исправить или забыть — поэтому «создать» здесь нет.
  'memory.actions.edit': 'Исправить',
  'memory.actions.forget': 'Забыть',
  'memory.actions.save': 'Сохранить',
  'memory.actions.cancel': 'Отмена',
  'memory.edit_title': 'Исправить запись: {key}',
  'memory.save_error': 'Не удалось сохранить запись',
  'memory.forget_confirm': 'Забыть эту запись?',
  'memory.forget_description': 'Агент перестанет учитывать этот факт в разговорах.',
  'memory.field.value': 'Факт',
  'memory.field.value_required': 'Текст не может быть пустым',
  'memory.field.value_reembed_hint':
    'После правки вектор пересчитается — поиск найдёт запись по новой формулировке.',
  'memory.field.importance': 'Важность (1–5)',
  'memory.field.pinned': 'Закрепить',

  // Dashboard widgets Week 8.
  'dashboard.page.title': 'Главная',
  'dashboard.page.subtitle': 'С возвращением! Вот сводка по вашим проектам и задачам.',
  'dashboard.customize.reset': 'Сбросить',
  'dashboard.customize.done': 'Готово',
  'dashboard.error.load_failed': 'Не удалось загрузить часть данных дашборда',
  'dashboard.error.retry': 'Повторить',
  'dashboard.customize.button': 'Настроить',
  'dashboard.customize.add_widget': 'Добавить виджет',
  'dashboard.customize.move_up': 'Переместить {label} вверх',
  'dashboard.customize.move_down': 'Переместить {label} вниз',
  'dashboard.customize.remove': 'Убрать {label}',
  'dashboard.customize.add': 'Добавить {label}',
  'dashboard.customize.width': 'Ширина',
  'dashboard.customize.width_for': 'Ширина: {label}',
  'dashboard.customize.clear_width': 'Сбросить ширину',
  'dashboard.customize.local_hint':
    'Раскладка сохраняется локально на этом устройстве; ширина применяется только на десктопе, на мобильном — одна колонка.',
  'dashboard.customize.width_label.one_third': '1/3',
  'dashboard.customize.width_label.half': '1/2',
  'dashboard.customize.width_label.two_thirds': '2/3',
  'dashboard.customize.width_label.full': 'Во всю ширину',
  'dashboard.customize.width_aria.one_third': 'Ширина одна треть',
  'dashboard.customize.width_aria.half': 'Ширина половина',
  'dashboard.customize.width_aria.two_thirds': 'Ширина две трети',
  'dashboard.customize.width_aria.full': 'Ширина во всю ширину',
  'dashboard.widgets.stats': 'Сводка',
  'dashboard.widgets.focus': 'Фокус на сегодня',
  'dashboard.widgets.pipelineBoard': 'Воронка сделок',
  'dashboard.widgets.week': 'Неделя',
  'dashboard.widgets.revenueGoal': 'Цель месяца',
  'dashboard.widgets.telegramLeads': 'Лиды из Telegram',
  'dashboard.widgets.savedViews': 'Сохранённые представления',
  'dashboard.widgets.workforce': 'Сигналы AI',
  'dashboard.widgets.burndown': 'Динамика сделок',
  'dashboard.widgets.pipelines': 'Этапы сделок',
  'dashboard.widgets.activity': 'Последняя активность',
  'dashboard.widgets.calendar': 'Календарь',
  'dashboard.widgets.actions': 'Быстрые действия',
  'dashboard.widgets.notifications': 'Уведомления',
  'dashboard.widgets.openTasks': 'Открытые задачи',
  'dashboard.widgets.attentionQueue': 'Деньги под риском',
  'dashboard.widgets.myDay': 'Мой день',
  'dashboard.widgets.portfolio': 'Портфель',
  'dashboard.widgets.budget': 'Бюджет',
  'dashboard.widgets.agents': 'Агенты',
  'dashboard.widgets.trends': 'Тренды',
  'dashboard.widgets.swarm': 'Рой',
  'dashboard.widgets.heatmap': 'Тепловая карта',
  'dashboard.widgets.pipeburn': 'Сгорание воронки',
  'dashboard.widgets.clock': 'Часы',
  'dashboard.widgets.notes': 'Свежие заметки',
  'dashboard.widgets.nexus': 'Связи',
  'dashboard.widgets.island': 'Остров',
  'dashboard.widgets.quote': 'Цитата',
  'dashboard.widgets.flatmedia': 'Flatmedia',
  'dashboard.presets.ceo': 'CEO',
  'dashboard.presets.sales': 'Продажи',
  'dashboard.presets.pm': 'PM',
  'dashboard.presets.dev': 'Dev',
  'dashboard.presets.creative': 'Дизайн',
  'dashboard.presets.flatmedia': 'Flatmedia',
  'dashboard.presets.group': 'Пресеты дашборда',
  'dashboard.presets.more': 'Ещё',
  'dashboard.stats.projects': 'Сделки',
  'dashboard.stats.active': 'В работе',
  'dashboard.stats.tasks_done': 'Горячие лиды',
  'dashboard.stats.sessions': 'Активные сценарии',
  'dashboard.stats.sessions_suffix': 'активно',
  'dashboard.stats.success_rate': 'Успешные сделки',
  'dashboard.stats.total_cost': 'Ожидают подтверждения',
  'dashboard.focus.title': 'Очередь внимания (фокус дня)',
  'dashboard.focus.view_all': 'Показать всё',
  'dashboard.focus.empty': 'Приоритетных задач и сигналов нет. Всё под контролем.',
  'dashboard.focus.no_project': 'Без проекта',
  'dashboard.focus.priority.high': 'Высокий',
  'dashboard.focus.priority.mid': 'Средний',
  'dashboard.focus.priority.low': 'Низкий',
  'dashboard.focus.last_contact': 'контакт',
  'dashboard.focus.pending_approval_title': 'Согласование действия агента',
  'dashboard.focus.pending_approval_subtitle': 'Ожидает решения в очереди подтверждений',
  'dashboard.focus.no_next_step': 'Нет следующего действия',
  'dashboard.focus.overdue_task': 'Просроченная задача',
  'dashboard.focus.today_meeting': 'Встреча сегодня',
  'dashboard.focus.actions.decide': 'Согласовать',
  'dashboard.focus.actions.view_deal': 'В сделку',
  'dashboard.focus.actions.plan_step': 'Назначить шаг',
  'dashboard.focus.actions.view_task': 'К задаче',
  'dashboard.focus.actions.open_chat': 'В AI-чат',
  'dashboard.focus.prompts.deal_recovery':
    'Предложи лучший следующий шаг и план действий по сделке «{dealTitle}».',
  'dashboard.focus.prompts.plan_step': 'Составь план следующего контакта по сделке «{dealTitle}».',
  'chat.email_draft.copy_text': 'Копировать текст',
  'chat.email_draft.copied': 'Скопировано в буфер',
  'chat.email_draft.edit': 'Редактировать',
  'chat.email_draft.save_edit': 'Готово',
  'chat.email_draft.send_manual': 'Отправить вручную',
  'chat.email_draft.manual_sent': 'Отправлено вручную',
  'chat.email_draft.subject_label': 'Тема письма',
  'chat.email_draft.body_label': 'Текст письма',
  'projects.copilot.suggestion_changes': 'Что изменилось в проекте?',
  'projects.copilot.suggestion_changes_prompt':
    'Проанализируй текущий проект {projectName} ({projectId}): что изменилось за последнее время по задачам, заметкам и встречам?',
  'projects.copilot.suggestion_next_steps': 'Что дальше по задачам?',
  'projects.copilot.suggestion_next_steps_prompt':
    'Проанализируй задачи проекта {projectName} ({projectId}) и предложи приоритетные следующие шаги.',
  'projects.copilot.suggestion_brief': 'Собрать бриф проекта',
  'projects.copilot.suggestion_brief_prompt':
    'Собери краткий бриф по проекту {projectName} ({projectId}): цели, участники, текущий прогресс и блокеры.',
  'dashboard.workforce.title': 'Сигналы AI',
  'dashboard.workforce.active_count': '{count} активно',
  'dashboard.workforce.empty': 'Активных сигналов пока нет',
  'dashboard.workforce.signal.scenario_run': 'Активный сценарий',
  'dashboard.workforce.signal.pending_approval': 'Ожидает подтверждения',
  'dashboard.workforce.type.opencode': 'opencode',
  'dashboard.workforce.type.antigravity': 'antigravity',
  'dashboard.workforce.type.agent': 'агент',
  'dashboard.burndown.title': 'Динамика сделок',
  'dashboard.burndown.empty': 'История по динамике пока не накопилась.',
  'dashboard.burndown.ideal': 'План',
  'dashboard.burndown.remaining': 'Осталось',
  'dashboard.pipelines.title': 'Этапы сделок',
  'dashboard.pipeline_board.title': 'Воронка сделок',
  'dashboard.pipeline_board.column.new': 'Новые',
  'dashboard.pipeline_board.column.progress': 'В работе',
  'dashboard.pipeline_board.column.payment': 'К оплате',
  'dashboard.pipeline_board.kanban_link': 'Канбан',
  'dashboard.pipeline_board.empty': 'Сделок в воронке пока нет',
  'dashboard.pipeline_board.hint_today': 'сегодня',
  'dashboard.pipeline_board.hint_overdue': 'просрочка',
  'dashboard.week_strip.events_count': '{count} записей',
  'dashboard.week_strip.calendar_link': 'Календарь',
  'dashboard.week_strip.empty': 'На этой неделе событий нет',
  'dashboard.revenue_goal.title': 'Цель месяца',
  'dashboard.revenue_goal.open': 'Сделки',
  'dashboard.revenue_goal.of': 'из',
  'dashboard.revenue_goal.days_left': {
    one: '{count} день до конца месяца',
    few: '{count} дня до конца месяца',
    many: '{count} дней до конца месяца',
    other: '{count} дней до конца месяца',
  },
  'dashboard.revenue_goal.progress_label': 'Прогресс к цели месяца',
  'dashboard.telegram_leads.title': 'Лиды из Telegram',
  'dashboard.telegram_leads.open': 'Очередь',
  'dashboard.telegram_leads.pending': 'на проверке',
  'dashboard.telegram_leads.empty': 'Новых заявок нет',
  'dashboard.telegram_leads.no_access': 'Доступно владельцу и админу',
  'dashboard.pipelines.empty': 'Активных этапов пока нет',
  'dashboard.activity.title': 'Последняя активность',
  'dashboard.activity.events_count': '{count} событий',
  'dashboard.activity.empty': 'Свежей активности пока нет',
  'dashboard.activity.fallback_title': 'Активность',
  'dashboard.activity.kind.deal_created': 'Сделка создана',
  'dashboard.activity.kind.deal_updated': 'Сделка обновлена',
  'dashboard.activity.kind.deal_stage_changed': 'Этап сделки изменён',
  'dashboard.activity.kind.deal_deleted': 'Сделка удалена',
  'dashboard.activity.kind.contact_created': 'Контакт создан',
  'dashboard.activity.kind.contact_updated': 'Контакт обновлён',
  'dashboard.activity.kind.contact_deleted': 'Контакт удалён',
  'dashboard.activity.kind.email_sent': 'Письмо отправлено',
  'dashboard.activity.kind.email_opened': 'Письмо открыто',
  'dashboard.activity.kind.email_clicked': 'Клик по ссылке в письме',
  'dashboard.activity.kind.call_made': 'Совершён звонок',
  'dashboard.activity.kind.meeting_scheduled': 'Встреча запланирована',
  'dashboard.activity.kind.meeting_updated': 'Встреча обновлена',
  'dashboard.activity.kind.meeting_cancelled': 'Встреча отменена',
  'dashboard.activity.kind.note_added': 'Заметка добавлена',
  'dashboard.activity.kind.note_updated': 'Заметка обновлена',
  'dashboard.activity.kind.note_deleted': 'Заметка удалена',
  'dashboard.activity.kind.ai_tool_invoked': 'AI-инструмент запущен',
  'dashboard.activity.kind.scenario_started': 'Сценарий запущен',
  'dashboard.activity.kind.scenario_completed': 'Сценарий завершён',
  'dashboard.activity.kind.task_created': 'Задача создана',
  'dashboard.activity.kind.task_updated': 'Задача обновлена',
  'dashboard.activity.kind.task_status_changed': 'Статус задачи изменён',
  'dashboard.activity.kind.task_deleted': 'Задача удалена',
  'dashboard.activity.kind.task_due_reminder': 'Напоминание о задаче',
  'dashboard.activity.kind.company_created': 'Компания создана',
  'dashboard.activity.kind.company_updated': 'Компания обновлена',
  'dashboard.activity.kind.company_deleted': 'Компания удалена',
  'dashboard.activity.kind.interaction_logged': 'Взаимодействие записано',
  'dashboard.activity.kind.interaction_updated': 'Взаимодействие обновлено',
  'dashboard.activity.kind.interaction_deleted': 'Взаимодействие удалено',
  'dashboard.activity.kind.document_created': 'Документ создан',
  'dashboard.activity.kind.document_updated': 'Документ обновлён',
  'dashboard.activity.kind.document_deleted': 'Документ удалён',
  'dashboard.activity.kind.template_created': 'Шаблон создан',
  'dashboard.activity.kind.template_updated': 'Шаблон обновлён',
  'dashboard.activity.kind.template_deleted': 'Шаблон удалён',
  'dashboard.activity.kind.project_created': 'Проект создан',
  'dashboard.activity.kind.project_updated': 'Проект обновлён',
  'dashboard.activity.kind.project_deleted': 'Проект удалён',
  'dashboard.activity.kind.attachment_added': 'Вложение добавлено',
  'dashboard.activity.kind.attachment_deleted': 'Вложение удалено',
  'dashboard.activity.kind.entity_link_added': 'Связь добавлена',
  'dashboard.activity.kind.entity_link_removed': 'Связь удалена',
  'dashboard.calendar.title': 'Ближайшие действия',
  'dashboard.calendar.empty': 'Ближайших действий пока нет',
  'dashboard.calendar.overdue': 'просрочено',
  'dashboard.calendar.today': 'сегодня',
  'dashboard.calendar.tomorrow': 'завтра',
  'dashboard.calendar.in_days': 'через {count}д',
  'dashboard.actions.title': 'Быстрые действия',
  'dashboard.actions.new_project.label': 'Новый проект',
  'dashboard.actions.new_project.subtitle': 'Создать рабочее пространство',
  'dashboard.actions.summon_agent.label': 'Позвать AI',
  'dashboard.actions.summon_agent.subtitle': 'Быстрый запуск помощника',
  'dashboard.actions.new_pipeline.label': 'Новая воронка',
  'dashboard.actions.new_pipeline.subtitle': 'Настроить этапы работы',
  'dashboard.actions.analytics.label': 'Аналитика',
  'dashboard.actions.analytics.subtitle': 'Посмотреть метрики',
  'dashboard.actions.settings.label': 'Настройки',
  'dashboard.actions.settings.subtitle': 'Параметры системы',
  'dashboard.notifications.title': 'Уведомления',
  'dashboard.notifications.mark_all_read': 'Отметить всё прочитанным',
  'dashboard.notifications.empty': 'Уведомлений пока нет',
  'dashboard.notifications.approval.title': 'Требуется согласование действия агента',
  'dashboard.notifications.approval.body': 'Действие «{kind}» ждёт решения в очереди подтверждений',
  'dashboard.notifications.approval.kind.tool_call': 'Вызов инструмента',
  'dashboard.notifications.approval.kind.scenario_step': 'Шаг сценария',
  'dashboard.notifications.approval.kind.contact_delete': 'Удаление контакта',
  'dashboard.notifications.approval.kind.deal_delete': 'Удаление сделки',
  'dashboard.notifications.hot_lead.title': 'Горячая сделка: {title}',
  'dashboard.notes.title': 'Свежие заметки',
  'dashboard.notes.view_all': 'Показать всё',
  'dashboard.notes.empty': 'Заметок пока нет',
  'dashboard.notes.unknown_author': 'Неизвестный автор',
  'dashboard.open_tasks.title': 'Открытые задачи',
  'dashboard.open_tasks.view_all': 'Показать всё',
  'dashboard.open_tasks.empty': 'Открытых задач пока нет',
  'dashboard.open_tasks.no_due': 'Без срока',
  'dashboard.open_tasks.status.todo': 'К работе',
  'dashboard.open_tasks.status.in_progress': 'В работе',
  'dashboard.open_tasks.status.blocked': 'Заблокирована',
  'dashboard.my_day.title': 'Мой день',
  'dashboard.my_day.priority.meetings': 'Встречи',
  'dashboard.my_day.priority.overdue_tasks': 'Просроченные задачи',
  'dashboard.my_day.priority.risk_deals': 'Сделки с риском',
  'dashboard.my_day.priority.hot_leads': 'Горячие сделки',
  'dashboard.my_day.meetings': 'Встречи сегодня',
  'dashboard.my_day.hot_leads': 'Горячие сделки',
  'dashboard.my_day.overdue_tasks': 'Просроченные задачи',
  'dashboard.my_day.risk_deals': 'Сделки с риском',
  'dashboard.my_day.pipeline': 'Воронка',
  'dashboard.my_day.conversion': 'Конверсия',
  'dashboard.my_day.empty': 'На сегодня всё спокойно',
  'dashboard.my_day.error': 'Не удалось загрузить сводку дня',
  'dashboard.my_day.retry': 'Повторить',
  'dashboard.my_day.run_ai': 'Открыть AI-разбор: {label}',
  'dashboard.my_day.no_priority_records': 'Нет записей для разбора',
  'dashboard.my_day.propose_strategy': 'Стратегия',
  'dashboard.my_day.sales_health.title': 'Здоровье продаж',
  'dashboard.my_day.sales_health.active': 'Активные сделки',
  'dashboard.my_day.sales_health.attention': 'Требуют внимания',
  'dashboard.my_day.sales_health.critical': 'Критичные',
  'dashboard.my_day.sales_health.level_healthy': 'Здоровая',
  'dashboard.my_day.sales_health.level_attention': 'Внимание',
  'dashboard.my_day.sales_health.level_critical': 'Критичная',
  'dashboard.my_day.sales_health.empty': 'Открытая воронка пуста — прогноза пока нет.',
  'dashboard.my_day.sales_health.all_healthy': 'Все сделки воронки здоровы.',
  'dashboard.my_day.sales_health.error': 'Не удалось загрузить здоровье продаж',
  'dashboard.my_day.sales_health.disclaimer':
    'Эвристика CRM, только для чтения: стадия и сигналы риска. Данные не изменялись.',
  'dashboard.agent_widgets.title': 'Виджеты от агента',
  'dashboard.agent_widgets.remove_block': 'Убрать блок {label}',
  'dashboard.time.just_now': 'только что',
  'dashboard.time.minutes_ago': '{count}м назад',
  'dashboard.time.hours_ago': '{count}ч назад',
  'dashboard.time.days_ago': '{count}д назад',
  'approvals.summary.create_calendar_event': 'Создать событие календаря',
  'approvals.summary.update_calendar_event': 'Изменить событие календаря',
  'approvals.summary.cancel_calendar_event': 'Отменить событие календаря',
  'approvals.summary.reschedule_calendar_event': 'Перенести событие календаря',
  'approvals.summary.link_calendar_event_participant': 'Добавить участника события',
  'approvals.summary.unlink_calendar_event_participant': 'Удалить участника события',
  'approvals.summary.create_document': 'Создать документ',
  'approvals.summary.update_document': 'Изменить документ',
  'approvals.summary.delete_document': 'Удалить документ',
  'approvals.summary.link_document': 'Привязать документ',
  'approvals.summary.unlink_document': 'Отвязать документ',
  'approvals.summary.transition_document_status': 'Изменить статус документа',
  'approvals.summary.create_template': 'Создать шаблон',
  'approvals.summary.update_template': 'Изменить шаблон',
  'approvals.summary.delete_template': 'Удалить шаблон',
  'approvals.summary.activate_template': 'Активировать шаблон',
  'approvals.summary.deactivate_template': 'Деактивировать шаблон',
  'approvals.summary.link_attachment': 'Привязать вложение',
  'approvals.summary.unlink_attachment': 'Отвязать вложение',
  'approvals.summary.delete_attachment': 'Удалить вложение',
  'approvals.bulk.summary.create_calendar_events': 'Массово создать события календаря',
  'approvals.bulk.summary.update_calendar_events': 'Массово изменить события календаря',
  'approvals.bulk.summary.cancel_calendar_events': 'Массово отменить события календаря',
  'approvals.bulk.summary.reschedule_calendar_events': 'Массово перенести события календаря',
  'approvals.bulk.summary.link_calendar_event_participants': 'Массово добавить участников событий',
  'approvals.bulk.summary.unlink_calendar_event_participants': 'Массово удалить участников событий',
  'approvals.bulk.summary.create_contact_interactions': 'Массово создать взаимодействия',
  'approvals.bulk.summary.update_contact_interactions': 'Массово изменить взаимодействия',
  'approvals.bulk.summary.delete_contact_interactions': 'Массово удалить взаимодействия',
  'approvals.bulk.summary.create_documents': 'Массово создать документы',
  'approvals.bulk.summary.update_documents': 'Массово изменить документы',
  'approvals.bulk.summary.delete_documents': 'Массово удалить документы',
  'approvals.bulk.summary.create_templates': 'Массово создать шаблоны',
  'approvals.bulk.summary.update_templates': 'Массово изменить шаблоны',
  'approvals.bulk.summary.delete_templates': 'Массово удалить шаблоны',
  'approvals.bulk.summary.activate_templates': 'Массово активировать шаблоны',
  'approvals.bulk.summary.deactivate_templates': 'Массово деактивировать шаблоны',
  'approvals.bulk.summary.link_attachments': 'Массово привязать вложения',
  'approvals.bulk.summary.unlink_attachments': 'Массово отвязать вложения',
  'approvals.bulk.summary.delete_attachments': 'Массово удалить вложения',
  'ai_chat.action_plan.title': 'Запрошенные действия',
  'ai_chat.action_plan.approve': 'Подтвердить действие',
  'ai_chat.action_plan.reject': 'Отклонить',
  'ai_chat.action_plan.undo': 'Отменить результат',
  'ai_chat.action_plan.empty_value': 'Не указано',
  'ai_chat.action_plan.blocked_dependency': 'Станет доступно после предыдущего действия.',
  'ai_chat.action_plan.stale_details':
    'После выполнения запись изменилась. Перед отменой проверьте актуальные данные.',
  'ai_chat.action_plan.status.blocked': 'Ждёт предыдущее действие',
  'ai_chat.action_plan.status.pending': 'Ожидает подтверждения',
  'ai_chat.action_plan.status.approved': 'Подтверждено',
  'ai_chat.action_plan.status.rejected': 'Отклонено',
  'ai_chat.action_plan.status.succeeded': 'Выполнено',
  'ai_chat.action_plan.status.failed': 'Ошибка',
  'ai_chat.action_plan.status.cancelled': 'Отменено',
  'ai_chat.action_plan.status.undo_pending': 'Отмена ожидает подтверждения',
  'ai_chat.action_plan.status.undone': 'Результат отменён',
  'ai_chat.action_plan.status.stale': 'Данные изменились',
  'ai_chat.action_plan.entity.company': 'Компания',
  'ai_chat.action_plan.entity.contact': 'Контакт',
  'ai_chat.action_plan.entity.deal': 'Сделка',
  'ai_chat.action_plan.entity.task': 'Задача',
  'ai_chat.action_plan.entity.note': 'Заметка',
  'ai_chat.action_plan.entity.calendar_event': 'Событие календаря',
  'ai_chat.action_plan.entity.contact_interaction': 'Взаимодействие',
  'ai_chat.action_plan.action.create_company': 'Создать компанию',
  'ai_chat.action_plan.action.create_contact': 'Создать контакт',
  'ai_chat.action_plan.action.create_deal': 'Создать сделку',
  'ai_chat.action_plan.action.create_task': 'Создать задачу',
  'ai_chat.task_kanban.title': 'Задачи сделки',
  'ai_chat.task_kanban.error': 'Не удалось загрузить задачи',
  'ai_chat.task_kanban.expand': 'Развернуть канбан задач',
  'ai_chat.task_kanban.collapse': 'Свернуть канбан задач',
  'ai_chat.task_kanban.create': 'Создать задачу',
  'ai_chat.action_plan.action.create_calendar_event': 'Создать событие календаря',
  'ai_chat.action_plan.action.create_contact_interaction': 'Записать взаимодействие с контактом',
  'ai_chat.action_plan.action.create_note': 'Создать заметку',
  'ai_chat.action_plan.action.create_document': 'Создать документ',
  'ai_chat.action_plan.action.create_template': 'Создать шаблон',
  'ai_chat.action_plan.action.update_task': 'Обновить задачу',
  'ai_chat.action_plan.action.update_company': 'Обновить компанию',
  'ai_chat.action_plan.action.update_contact': 'Обновить контакт',
  'ai_chat.action_plan.action.update_deal': 'Обновить сделку',
  'ai_chat.action_plan.action.update_note': 'Обновить заметку',
  'ai_chat.action_plan.action.update_document': 'Обновить документ',
  'ai_chat.action_plan.action.update_template': 'Обновить шаблон',
  'ai_chat.action_plan.action.update_calendar_event': 'Обновить событие календаря',
  'ai_chat.action_plan.action.delete_company': 'Удалить компанию',
  'ai_chat.action_plan.action.delete_contact': 'Удалить контакт',
  'ai_chat.action_plan.action.delete_deal': 'Удалить сделку',
  'ai_chat.action_plan.action.delete_task': 'Удалить задачу',
  'ai_chat.action_plan.action.delete_note': 'Удалить заметку',
  'ai_chat.action_plan.action.delete_document': 'Удалить документ',
  'ai_chat.action_plan.action.delete_template': 'Удалить шаблон',
  'ai_chat.action_plan.action.cancel_calendar_event': 'Отменить событие календаря',
  'ai_chat.action_plan.undo_used_downstream':
    'Результат использован следующим шагом — отмена недоступна.',
  'ai_chat.action_plan.entity.document': 'Документ',
  'ai_chat.action_plan.entity.template': 'Шаблон',
  'ai_chat.action_plan.action.bulk_group_apply': 'Массовая операция',
  'ai_chat.action_plan.bulk.total': 'Всего целей: {count}',
  'ai_chat.action_plan.bulk.succeeded': 'Успешно: {count}',
  'ai_chat.action_plan.bulk.failed': 'С ошибками: {count}',
  'ai_chat.action_plan.bulk.skipped': 'Пропущено: {count}',
  'ai_chat.action_plan.bulk.stale': 'Изменились: {count}',
  'ai_chat.action_plan.bulk.unfinished': 'Не завершено: {count}',
  'ai_chat.action_plan.bulk.sample_title': 'Элементы (первые {count})',
  'ai_chat.action_plan.bulk.item_status.pending': 'Ожидает',
  'ai_chat.action_plan.bulk.item_status.succeeded': 'Успешно',
  'ai_chat.action_plan.bulk.item_status.failed': 'Ошибка',
  'ai_chat.action_plan.bulk.item_status.skipped': 'Пропущено',
  'ai_chat.action_plan.bulk.item_status.stale': 'Изменилось',
  'telegram.approval.completed': 'Выполнено',
  'telegram.approval.rejected': 'Отклонено',
  'telegram.approval.expired': 'Подтверждение истекло',
  'telegram.approval.not_completed': 'Подтверждено, но операция не выполнена',
  'telegram.approval.approve': 'Подтвердить',
  'telegram.approval.reject': 'Отклонить',
  'ai_chat.action_plan.retry_prepared':
    'Подготовлено новое подтверждение для повтора. Операция ещё не выполнена.',
  'ai_chat.action_plan.retry_before_effect':
    'Шаг остановлен до выполнения. Повтор потребует нового подтверждения.',
  'ai_chat.action_plan.retry': 'Повторить шаг',
  'ai_chat.action_plan.retry_failed':
    'Не удалось подготовить повтор. Обновите план и проверьте состояние шага.',
  'ai_chat.action_plan.bulk.retry': 'Завершить оставшиеся',
  'ai_chat.action_plan.action.unspecified': 'Действие в CRM',
  'ai_chat.action_plan.field.name': 'Название',
  'ai_chat.action_plan.field.first_name': 'Имя',
  'ai_chat.action_plan.field.last_name': 'Фамилия',
  'ai_chat.action_plan.field.phone': 'Телефон',
  'ai_chat.action_plan.field.email': 'Email',
  'ai_chat.action_plan.field.title': 'Название',
  'ai_chat.action_plan.field.amount': 'Сумма',
  'ai_chat.action_plan.field.stage': 'Этап',
  'ai_chat.action_plan.field.company': 'Компания',
  'ai_chat.action_plan.field.contact': 'Контакт',
  'ai_chat.action_plan.field.deal': 'Сделка',
  'ai_chat.action_plan.field.due_at': 'Срок',
  'ai_chat.action_plan.field.description': 'Описание',
  'ai_chat.action_plan.field.priority': 'Приоритет',
  'ai_chat.action_plan.field.starts_at': 'Начало',
  'ai_chat.action_plan.field.ends_at': 'Окончание',
  'ai_chat.action_plan.field.timezone': 'Часовой пояс',
  'ai_chat.action_plan.field.location': 'Место',
  'ai_chat.action_plan.field.type': 'Тип',
  'ai_chat.action_plan.field.subject': 'Тема',
  'ai_chat.action_plan.field.body': 'Содержание',
  'ai_chat.action_plan.field.channel': 'Канал',
  'ai_chat.action_plan.field.occurred_at': 'Когда',

  // Run Center (журнал автоматизаций)
  'run_center.title': 'Run Center',
  'run_center.subtitle':
    'Журнал автоматизаций: какие сценарии запускались, для каких сделок и с каким результатом. Изменения статусов появляются автоматически.',
  'run_center.stats.total': 'Всего запусков',
  'run_center.stats.running': 'Выполняются',
  'run_center.stats.awaiting': 'Ожидают подтверждения',
  'run_center.stats.completed': 'Завершены',
  'run_center.stats.failed': 'Ошибки',
  'run_center.filter.scenario': 'Фильтр по сценарию',
  'run_center.filter.status': 'Фильтр по статусу',
  'run_center.filter.all_scenarios': 'Все сценарии',
  'run_center.filter.all_statuses': 'Все статусы',
  'run_center.refresh': 'Обновить журнал',
  'run_center.column.scenario': 'Сценарий',
  'run_center.column.deal': 'Сделка',
  'run_center.column.contact': 'Контакт',
  'run_center.column.status': 'Статус',
  'run_center.column.started': 'Запущен',
  'run_center.not_started': 'Ещё не запускался',
  'run_center.column.finished': 'Завершён',
  'run_center.column.scheduled': 'Следующая попытка',
  'run_center.column.attempts': 'Попытки',
  'run_center.column.outcome': 'Результат',
  'run_center.status.queued': 'В очереди',
  'run_center.status.running': 'Выполняется',
  'run_center.status.awaiting_approval': 'Ждёт подтверждения',
  'run_center.status.completed': 'Завершён',
  'run_center.status.failed': 'Ошибка',
  'run_center.status.cancelled': 'Отменён',
  'run_center.outcome.queued': 'Ожидает запуска',
  'run_center.outcome.in_progress': 'Выполняется',
  'run_center.outcome.waiting_approval': 'Ждёт вашего подтверждения',
  'run_center.outcome.follow_up_queued': 'Письмо поставлено в очередь отправки',
  'run_center.outcome.skipped': 'Пропущено: нет подходящих данных',
  'run_center.outcome.completed': 'Выполнен без изменений данных',
  'run_center.outcome.failed': 'Завершился ошибкой',
  'run_center.outcome.cancelled': 'Отменён',
  'run_center.outcome.unknown': 'Без изменений данных',
  'run_center.approval_link': 'Требует решения',
  'run_center.empty.title': 'Пока нет запусков',
  'run_center.empty.description':
    'Здесь появятся запуски сценариев — например, после перехода сделки на этап «Contacted».',
  'run_center.error.title': 'Не удалось загрузить журнал запусков',
  'run_center.error.description': 'Проверьте подключение и попробуйте ещё раз.',
  'run_center.preset.follow_up.name': 'Follow-up через 3 дня',
  'run_center.preset.graph_follow_up.name': 'Follow-up через 3 дня (граф)',
  'run_center.preset.my_day.name': 'Утренний «Мой день»',
  'run_center.scheduled_occurrence': '{date} в {time} ({timezone})',
  'run_center.my_day.summary':
    'Встреч: {meetings} · Просроченных задач: {overdue} · Рисковых сделок: {risks} · Лидов: {leads}',
  'run_center.my_day.summary_truncated': '{summary} · списки сокращены',
  'run_center.column.actions': 'Действия',
  'run_center.column.approval': 'Подтверждение',
  'run_center.action.cancel': 'Отменить',
  'run_center.action.retry': 'Повторить',
  'run_center.action.cancel_selected': 'Отменить выбранные ({count})',
  'run_center.action.retry_selected': 'Повторить выбранные ({count})',
  'run_center.confirm.cancel_title': 'Отменить запуск?',
  'run_center.confirm.cancel_description':
    'Запуск в ожидании подтверждения будет отменён. Связанное подтверждение тоже отменится.',
  'run_center.confirm.retry_title': 'Повторить запуск?',
  'run_center.confirm.retry_description':
    'Запуск будет поставлен в очередь заново с обнулёнными попытками.',
  'run_center.success.cancelled': 'Запуск отменён',
  'run_center.success.retried': 'Запуск поставлен в очередь',
  'run_center.error.cancel_failed': 'Не удалось отменить запуск',
  'run_center.error.retry_failed': 'Не удалось повторить запуск',
  'run_center.bulk.mixed_cancel_tooltip':
    'Выбраны запуски в разных статусах — отмена доступна только для ожидающих подтверждения',
  'run_center.bulk.mixed_retry_tooltip':
    'Выбраны запуски в разных статусах — повтор доступен только для ошибок',
  'run_center.bulk.cancel_confirm_title': 'Отменить выбранные запуски?',
  'run_center.bulk.cancel_confirm_description': 'Будет отменено запусков: {count}',
  'run_center.bulk.retry_confirm_title': 'Повторить выбранные запуски?',
  'run_center.bulk.retry_confirm_description': 'Будет поставлено в очередь: {count}',
  'run_center.upgrade.title': 'Требуется тариф Pro',
  'run_center.upgrade.description':
    'Run Center доступен на тарифах Pro и Agency: журнал автоматизаций, запуск сценариев и отмена по одной кнопке.',
  'run_center.upgrade.action': 'Перейти на Pro',

  // Automations preset library
  'automations.title': 'Автоматизации',
  'automations.subtitle':
    'Каталог готовых автоматизаций. Включите Follow-up через 3 дня, чтобы сделки после Contacted автоматически попадали в Run Center.',
  'automations.loading': 'Загружаем автоматизации...',
  'automations.empty_title': 'Нет доступных автоматизаций',
  'automations.empty_description': 'Пресеты появятся после обновления демо-данных.',
  'automations.error_title': 'Не удалось загрузить автоматизации',
  'automations.enabled': 'Включено',
  'automations.disabled': 'Выключено',
  'automations.toggle_on': 'Включить',
  'automations.toggle_off': 'Выключить',
  'automations.trigger': 'Триггер',
  'automations.condition': 'Условие',
  'automations.outcome': 'Результат',
  'automations.run_center_link': 'Открыть в Run Center',
  'automations.run_center_aria': 'Открыть запуски сценария {name} в Run Center',
  'automations.toggle_aria': 'Переключить автоматизацию {name}',
  'automations.updated': 'Состояние обновлено',
  'automations.update_failed': 'Не удалось изменить состояние. Попробуйте ещё раз.',
  'automations.refresh': 'Обновить',
  'automations.refresh_aria': 'Обновить список автоматизаций',
  'automations.preset.follow_up.name': 'Follow-up через 3 дня',
  'automations.preset.follow_up.description':
    'После перехода сделки в Contacted подождать 3 дня, собрать черновик письма и запросить подтверждение.',
  'automations.preset.follow_up.trigger': 'Событие',
  'automations.preset.follow_up.condition': 'Сделка переходит в Contacted',
  'automations.preset.follow_up.outcome': 'Ожидание 3 дня → черновик письма → запрос подтверждения',
  'automations.preset.graph_follow_up.name': 'Follow-up через 3 дня',
  'automations.preset.graph_follow_up.description':
    'После перехода сделки в Contacted подождать 3 дня, оценить риск и запросить подтверждение на постановку письма в очередь.',
  'automations.preset.graph_follow_up.trigger': 'Событие',
  'automations.preset.graph_follow_up.condition': 'Сделка переходит в Contacted',
  'automations.preset.graph_follow_up.outcome':
    'Ожидание 3 дня → анализ риска → подтверждение → письмо в очередь',
  'automations.preset.my_day.name': 'Утренний «Мой день»',
  'automations.preset.my_day.description':
    'Каждое утро в 09:00 (Europe/Moscow) собирать read-only сводку «Мой день» и завершаться кратким итогом.',
  'automations.preset.my_day.trigger': 'По расписанию',
  'automations.preset.my_day.schedule': 'Ежедневно в 09:00 (Europe/Moscow)',
  'automations.preset.my_day.condition': 'Наступает 09:00 Europe/Moscow',
  'automations.preset.my_day.outcome': 'Сводка «Мой день» → краткий итог в Run Center',
  'automations.preset.conversion_digest.name': 'Дайджест конверсии',
  'automations.preset.conversion_digest.description':
    'Ежедневно собирает ОДИН пост дайджеста конверсии: топ-5 горячих сделок с причиной и следующим шагом плюс сделки без касания N дней. Час и N задаются подпиской дайджеста конверсии в настройках Telegram.',
  'automations.preset.conversion_digest.trigger': 'По расписанию',
  'automations.preset.conversion_digest.schedule':
    'Ежедневно в час из подписки (часовой пояс воркспейса)',
  'automations.preset.conversion_digest.condition': 'Наступает час доставки из подписки',
  'automations.preset.conversion_digest.outcome':
    'Один пост → Telegram (по отдельному согласию) либо заметка в CRM',
  'conversion_digest.post.title': 'Дайджест конверсии — {date}',
  'conversion_digest.post.top_title': 'Топ сделок',
  'conversion_digest.post.top_empty': 'Горячих сделок нет.',
  'conversion_digest.post.reason': 'Причина',
  'conversion_digest.post.next_step': 'Следующий шаг',
  'conversion_digest.post.stagnation_title': 'Без касания {days}+ дней',
  'conversion_digest.post.stagnation_empty': 'Сделок без касания нет.',
  'conversion_digest.post.more': '…и ещё {count}',
  'conversion_digest.post.days': '{count} дн.',
  'conversion_digest.reason.overdue_next_activity': 'просрочено следующее действие',
  'conversion_digest.reason.overdue_task': 'просрочена задача по сделке',
  'conversion_digest.reason.missing_next_activity': 'не запланировано следующее действие',
  'conversion_digest.reason.stale_activity': 'нет недавней активности',
  'conversion_digest.reason.due': 'скоро наступает следующее действие',
  'conversion_digest.reason.high_value': 'крупная сделка',
  'conversion_digest.next_step.email': 'написать на почту',
  'conversion_digest.next_step.call': 'позвонить',
  'automations.trigger_type.event': 'Событие',
  'automations.trigger_type.manual': 'Вручную',
  'automations.trigger_type.scheduled': 'По расписанию',
  'automations.more': 'ещё',
  'automations.generic.condition': 'Условие задаётся конфигурацией',
  'automations.generic.outcome': 'Результат определяется шагами сценария',
  'automations.edit_aria': 'Редактировать автоматизацию {name}',
  'automations.graph_edit_unavailable':
    'Редактирование графа пока недоступно — используйте переключатель и Run Center',
  'automations.scheduled_edit_unavailable':
    'Редактирование расписания пока недоступно — используйте переключатель и Run Center',
  'automations.duplicate_aria': 'Дублировать автоматизацию {name}',
  'automations.create': 'Новый сценарий',

  // Редактор канонического workflow graph
  'graph_scenario_editor.create_title': 'Новая графовая автоматизация',
  'graph_scenario_editor.edit_title': 'Редактирование графовой автоматизации',
  'graph_scenario_editor.subtitle':
    'Проверенный workflow: событие Contacted, ожидание 3 дня, анализ риска, подтверждение и постановка письма в очередь.',
  'graph_scenario_editor.name_placeholder': 'например, Follow-up через 3 дня',
  'graph_scenario_editor.active': 'Включить после сохранения',
  'graph_scenario_editor.active_hint':
    'После включения новые подходящие переходы сделок будут автоматически создавать запуски.',
  'graph_scenario_editor.flow': 'Проверенный workflow',
  'graph_scenario_editor.trigger': 'Триггер',
  'graph_scenario_editor.wait': 'Ожидание',
  'graph_scenario_editor.wait_value': '3 дня',
  'graph_scenario_editor.analysis': 'Анализ риска',
  'graph_scenario_editor.approval': 'Подтверждение',
  'graph_scenario_editor.approval_value': 'Обязательно перед действием с письмом',
  'graph_scenario_editor.action': 'Действие после подтверждения',
  'graph_scenario_editor.subject': 'Тема письма',
  'graph_scenario_editor.body': 'Текст письма',
  'graph_scenario_editor.create': 'Создать графовый сценарий',
  'graph_scenario_editor.edit_action': 'Редактировать существующий граф',
  'graph_scenario_editor.created': 'Графовый сценарий создан',
  'graph_scenario_editor.saved': 'Графовый сценарий сохранён',
  'graph_scenario_editor.activation_failed':
    'Сценарий создан, но включить его не удалось. Его можно включить в карточке автоматизации.',

  // Scenario editor (ADR-030 variant B) — Master-Detail Drawer
  'scenario_editor.title': 'Редактор сценариев',
  'scenario_editor.library_title': 'Автоматизации',
  'scenario_editor.drawer_title': 'Редактирование сценария',
  'scenario_editor.drawer_subtitle': 'Пресет: {name} · версия {version}',
  'scenario_editor.loading': 'Загрузка сценария…',
  'scenario_editor.load_error': 'Не удалось загрузить сценарий',
  'scenario_editor.save': 'Сохранить',
  'scenario_editor.saving': 'Сохранение…',
  'scenario_editor.save_success': 'Сценарий сохранён (v{version})',
  'scenario_editor.save_error': 'Не удалось сохранить сценарий',
  'scenario_editor.validation_error': 'Проверьте поля и попробуйте снова',
  'scenario_editor.version_conflict': 'Конфликт версий — перезагрузите и попробуйте снова',
  'scenario_editor.forbidden': 'Недостаточно прав',
  'scenario_editor.upgrade_needed': 'Обновите тариф, чтобы активировать больше сценариев',
  'scenario_editor.duplicate': 'Дублировать',
  'scenario_editor.duplicate_success': 'Сценарий дублирован',
  'scenario_editor.create_from_preset': 'Создать из пресета',
  'scenario_editor.create_from_preset_aria': 'Создать сценарий из пресета {name}',
  'scenario_editor.create_success': 'Сценарий создан',
  'scenario_editor.preset_picker_title': 'Выберите пресет',
  'scenario_editor.preset_picker_empty': 'Нет доступных пресетов',
  'scenario_editor.preset_key_label': 'Ключ пресета',
  'scenario_editor.config_label': 'Конфигурация (JSON)',
  'scenario_editor.config_hint': 'Проверяется как ScenarioConfig {id, triggers, steps}',
  'scenario_editor.close': 'Закрыть',
  'scenario_editor.cancel': 'Отмена',
  'scenario_editor.edit': 'Редактировать',
  'scenario_editor.field.name': 'Название',
  'scenario_editor.field.name_placeholder': 'напр. Follow-up через 3 дня',
  'scenario_editor.field.description': 'Описание',
  'scenario_editor.field.trigger': 'Триггер',
  'scenario_editor.field.trigger_deal_stage': 'Стадия сделки → Contacted',
  'scenario_editor.field.trigger_manual': 'Вручную',
  'scenario_editor.field.trigger_scheduled': 'По расписанию',
  'scenario_editor.field.trigger_event': 'По событию',
  'scenario_editor.field.wait_duration': 'Пауза',
  'scenario_editor.field.wait_3d': 'Ждать 3 дня',
  'scenario_editor.field.steps': 'Шаги',
  'scenario_editor.field.step_wait': 'Шаг 1 — Пауза',
  'scenario_editor.field.step_tool': 'Шаг 2 — Письмо (согласование)',
  'scenario_editor.field.version': 'Версия',
  'scenario_editor.field.isActive': 'Активен',
  'scenario_editor.field.advanced_json': 'Дополнительно (JSON)',
  'scenario_editor.field.advanced_json_hint':
    'Сырой config для будущих шагов — проверяется при сохранении',
  'scenario_editor.retry': 'Повторить',
  'scenario_editor.detail.version': 'v{version}',
  'scenario_editor.detail.updated': 'Обновлён {date}',
  'scenario_editor.detail.created': 'Создан {date}',

  // Workflows deprecated (ADR-030)
  'workflows.deprecated_title': 'Воркфлоу устарели — используйте Автоматизации',
  'workflows.deprecated_description':
    'Редактор воркфлоу перенесён в раздел Автоматизации. Создайте сценарий из пресета и редактируйте его в Drawer.',
  'workflows.deprecated_link': 'Перейти в Автоматизации',
  'workflows.title': 'Воркфлоу (n8n-style)',
  'workflows.subtitle':
    'Граф: nodes (trigger/tool/llm/condition/delay) + edges. Запуск из чата через «запусти сценарий X» (run_scenario) или по крону (cron в config).',
  'workflows.create_button': 'Новый воркфлоу',
  'workflows.create_modal_title': 'Новый воркфлоу',
  'workflows.empty':
    'Воркфлоу пока нет. Создайте первый — он появится здесь и станет доступен из чата.',
  'workflows.run': 'Запустить',
  'workflows.active': 'активен',
  'workflows.paused': 'пауза',
  'workflows.form.name_label': 'Название',
  'workflows.form.name_placeholder': 'Например: Follow-up через 3 дня',
  'workflows.form.trigger_label': 'Триггер',
  'workflows.form.trigger_manual': 'Ручной / из чата',
  'workflows.form.trigger_scheduled': 'По крону',
  'workflows.form.trigger_event': 'По событию',
  'workflows.form.graph_label': 'Граф (JSON: { nodes, edges, cron })',
  'workflows.form.graph_placeholder':
    '{\n  "nodes": [{ "id": "trigger", "type": "trigger", "params": { "kind": "manual" } }, { "id": "t1", "type": "tool", "params": { "tool": "create_task", "args": { "title": "Follow-up" } } }],\n  "edges": [{ "from": "trigger", "to": "t1" }],\n  "cron": "0 9 * * *"\n}',
  'workflows.hint':
    'Подсказка: узлы tool соответствуют любому CRM-тулу (create_task, send_email и т.д.), llm — промпт-шаг, condition — ветвление, delay — пауза. Cron в формате Crontab, проверяется воркером каждую минуту.',
  'workflows.create_error': 'Не удалось создать воркфлоу',

  // Imports preview.
  'imports.preview.title': 'Превью: {totalRows} строк',
  'imports.preview.title_truncated':
    'Превью: показаны первые {shown} из {totalRows} строк (лимит импорта)',

  // Pending invitations banner
  'pending_invitations.invited_message': 'Вас пригласили в «{workspace}» как {role}',
  'pending_invitations.expires_info': 'Приглашение на {email} · действует до {date}',
  'pending_invitations.accepted_message': 'Принято — вы участник «{workspace}»',
  'pending_invitations.switch_workspace': 'Перейти в пространство',

  'deal_card.next_best_action_btn': 'Подготовить follow-up',
  'dashboard.morning_briefing.title': 'Брифинг дня',
  'dashboard.morning_briefing.subtitle': 'Сводка по данным CRM за сегодня.',
  'dashboard.morning_briefing.expand': 'Развернуть',
  'dashboard.morning_briefing.ai_badge': 'ИИ',
  'dashboard.morning_briefing.collapse': 'Свернуть',
  'dashboard.morning_briefing.hot_leads': 'горячие',
  'dashboard.morning_briefing.overdue_tasks': 'просрочено',
  'dashboard.morning_briefing.meetings': 'встречи сегодня',
  'dashboard.morning_briefing.risk_deals': 'сделки с риском',
  'dashboard.morning_briefing.conversion': 'конверсия',
  'dashboard.morning_briefing.run_ai': 'Разобрать с ИИ',
  'dashboard.morning_briefing.error': 'Не удалось загрузить брифинг',
  'dashboard.morning_briefing.retry': 'Повторить',
  'dashboard.morning_briefing.empty': 'Данные брифинга появятся, когда в CRM появится активность.',
  'chat.compound.prepared':
    'Чтение выполнено. Связанная запись показана в плане; проверьте её статус и карточку подтверждения.',
  'chat.compound.ambiguous':
    'Найдено несколько записей. Уточните, какую использовать; запись не подготовлена.',
  'chat.compound.empty': 'Запись не найдена. Зависимое действие не подготовлено.',
  'chat.compound.failed': 'Не удалось безопасно подготовить зависимое действие. CRM не изменена.',
  'chat.compound.stale': 'Исходная запись изменилась. Зависимое действие не подготовлено.',
  'chat.compound.conflict':
    'Этот запрос уже обрабатывается или его сохранённая версия изменилась. Новое действие не создано.',
  'chat.compound.unsupported':
    'Для этого составного запроса пока нельзя безопасно подготовить связанное действие. Уточните запрос.',
  'chat.compound.step.read': 'Чтение',
  'chat.compound.step.write': 'Изменение',
  'chat.compound.selection_unknown':
    'Не удалось однозначно выбрать запись. Укажите её номер или точное имя из списка.',
  'chat.compound.selection_conflict':
    'Этот выбор относится к прежней версии плана или запись изменилась. Повторите исходный запрос.',
  'chat.compound.selection_unavailable':
    'Сохранённый выбор недоступен. Повторите исходный запрос, чтобы получить актуальный список.',
  'chat.compound.selection_used': 'Этот выбор уже использован — действие подготовлено выше.',
  'chat.compound.correction_prepared':
    'Поправка сохранена. Прежнее подтверждение отменено; проверьте новое действие.',
  'chat.compound.correction_conflict':
    'Это действие уже изменено или больше не ожидает подтверждения. Обновите чат и повторите поправку.',
  'chat.compound.correction_clarification':
    'Укажите, какое поле изменить: название, дату и время или контакт.',
  'chat.compound.matching_records': 'Подходящие записи:',
  'chat.compound.status.needs_clarification': 'Нужно уточнение',
  'chat.compound.status.pending': 'Ожидает подготовки',
  'chat.compound.status.blocked_by_dependency': 'Заблокировано зависимостью',
  'chat.compound.status.failed': 'Ошибка',
  'chat.compound.status.awaiting_approval': 'Ожидает подтверждения',
  'chat.compound.status.done': 'Готово',
  'chat.compound.batch_prepared_one': 'Подготовлена {count} задача. Подтверждайте по очереди.',
  'chat.compound.batch_prepared_few': 'Подготовлено {count} задачи. Подтверждайте по очереди.',
  'chat.compound.batch_prepared_many': 'Подготовлено {count} задач. Подтверждайте по очереди.',
  'chat.compound.batch_prepared_other': 'Подготовлено {count} задач. Подтверждайте по очереди.',
  'chat.compound.batch_write': 'Задача · {label}',
  'chat.compound.status.cancelled': 'Исключена',
  'chat.compound.batch_corrected': 'План обновлён.',
  'chat.compound.batch_bulk_title': 'Обновлено задач: {count} — название «{value}».',
  'chat.compound.batch_bulk_dueAt': 'Обновлено задач: {count} — срок {value}.',
  'chat.compound.batch_bulk_remove': 'Все задачи плана исключены. План закрыт.',
  'chat.compound.batch_bulk_skipped': 'Пропущены: {items}.',
  'chat.compound.batch_bulk_time_required':
    'Укажите время для задач {items}, например «в 10:00». День и набор задач сохранены; изменения ещё не внесены.',
  'chat.compound.batch_no_open': 'В плане нет задач, которые можно изменить.',
  'chat.compound.batch_skip_removed': 'исключена',
  'chat.compound.batch_skip_excluded': 'исключена из поправки',
  'chat.compound.batch_skip_succeeded': 'выполнена',
  'chat.compound.batch_skip_rejected': 'отклонена',
  'chat.compound.batch_skip_expired': 'срок подтверждения истёк',
  'chat.compound.batch_skip_failed': 'ошибка',
  'chat.compound.batch_skip_cancelled': 'отменена',
  'chat.compound.batch_skip_approved': 'уже подтверждена',
  'chat.compound.batch_skip_executing': 'выполняется',
  'chat.compound.batch_skip_undone': 'отменена после выполнения',
  'chat.compound.batch_skip_unavailable': 'недоступна для изменения',
  'chat.compound.batch_time_required':
    'Укажите время для задачи {count}, например «в 10:00». Выбранный день сохранён; задача ещё не изменена.',
  'chat.compound.batch_unchanged': 'Это изменение уже сохранено.',
  'chat.compound.batch_edit_title': 'Обновлено: задача {ordinal} — название «{value}».',
  'chat.compound.batch_edit_dueAt': 'Обновлено: задача {ordinal} — срок {value}.',
  'chat.compound.batch_edit_remove': 'Задача для {label} исключена. Осталось {count}.',
  'chat.compound.batch_choose_item':
    'Укажите одну задачу из списка её номером или полным именем записи. Изменения не внесены.',
  'chat.compound.batch_relation_bound':
    'Задача связана с исходной записью. Изменять или удалять эту связь нельзя; можно исключить задачу целиком.',
  'chat.compound.batch_closed': 'Этот план уже закрыт или заменён. Изменения не внесены.',
  'chat.compound.batch_item_unavailable':
    'Эта задача больше не ожидает подготовки или подтверждения. Изменения не внесены.',
  'chat.compound.batch_field_clarification':
    'Уточните один срок или одно название задачи. Изменения не внесены.',
  'chat.compound.batch_conflict': 'План уже изменён. Обновите чат и повторите поправку.',
  'chat.compound.batch_position': 'Позиция',
  'chat.compound.batch_position_value': '{position} из {count}',
  'chat.compound.batch_empty': 'Подходящих записей нет, задачи не подготовлены.',
  'chat.compound.batch_cap':
    'Найдено {count} записей — больше лимита 10. Уточните фильтр, задачи не подготовлены.',
  'chat.compound.batch_unparsed':
    'Не удалось однозначно разобрать условия. Переформулируйте: "Найди сделки без активности 30 дней и подготовь задачи «…» для каждой сделки, кроме закрытых".',
  'chat.compound.batch_unsupported':
    'Не удалось безопасно представить все условия и запреты. Уточните запрос; задачи не подготовлены.',
  'chat.compound.step.analysis': 'Анализ',
  'chat.compound.step.prepare': 'Подготовка',
  'ai_chat.action_plan.error.compound_source_changed':
    'Исходная запись изменилась или недоступна. Этот шаг пропущен; остальные действия продолжаются.',
  'chat.compound.batch_already_approved': 'План уже подтверждён, изменить его нельзя.',
  'ai_chat.action_plan.approve_remaining': 'Подтвердить оставшиеся ({count})',
  'ai_chat.action_plan.batch_group_stale': 'План изменился, обновите карточку.',
  'ai_chat.action_plan.batch_group_unavailable': 'Групповое подтверждение недоступно.',
  'ai_chat.action_plan.group_executing': 'Выполняется…',
  'ai_chat.action_plan.group_pending': 'Ожидает выполнения',
  'ai_chat.action_plan.group_succeeded': 'Создана',
  'ai_chat.action_plan.group_failed': 'Не выполнено',
  'chat.planner_write.existing':
    'Использована существующая запись: {name}. Контакт не создавался и не изменялся.',
  'chat.planner_write.not_applied': 'Не применено:',
  'chat.planner_write.field.firstName': 'Имя',
  'chat.planner_write.field.lastName': 'Фамилия',
  'chat.planner_write.field.phone': 'Телефон',
  'chat.planner_write.field.email': 'Email',
  'chat.planner_write.field.source': 'Источник',
};
